import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Input, Row, Col, Tag, Spin, Empty, Card, Pagination, Select, Button, message, Popconfirm, Tooltip, Space } from 'antd';
import { SearchOutlined, FireOutlined, ThunderboltOutlined, AppstoreOutlined, CaretUpOutlined, CaretDownOutlined, BarChartOutlined, HeartOutlined, ExperimentOutlined, MessageOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { modelAPI, configAPI, userModelConfigAPI, presetAPI } from '../services/api';
import { t } from '../utils/i18n';
import { getImageUrl } from '../utils/apiUrl';

// 模型SVG Logo映射
const modelLogos = {
  glm: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Zhipu</title>
      <path d="M11.991 23.503a.24.24 0 00-.244.248.24.24 0 00.244.249.24.24 0 00.245-.249.24.24 0 00-.22-.247l-.025-.001zM9.671 5.365a1.697 1.697 0 011.099 2.132l-.071.172-.016.04-.018.054c-.07.16-.104.32-.104.498-.035.71.47 1.279 1.186 1.314h.366c1.309.053 2.338 1.173 2.286 2.523-.052 1.332-1.152 2.38-2.478 2.327h-.174c-.715.018-1.274.64-1.239 1.368 0 .124.018.23.053.337.209.373.54.658.96.8.75.23 1.517-.125 1.9-.782l.018-.035c.402-.64 1.17-.96 1.92-.711.854.284 1.378 1.226 1.099 2.167a1.661 1.661 0 01-2.077 1.102 1.711 1.711 0 01-.907-.711l-.017-.035c-.2-.323-.463-.58-.851-.711l-.056-.018a1.646 1.646 0 00-1.954.746 1.66 1.66 0 01-1.065.764 1.677 1.677 0 01-1.989-1.279c-.209-.906.332-1.83 1.257-2.043a1.51 1.51 0 01.296-.035h.018c.68-.071 1.151-.622 1.116-1.333a1.307 1.307 0 00-.227-.693 2.515 2.515 0 01-.366-1.403 2.39 2.39 0 01.366-1.208c.14-.195.21-.444.227-.693.018-.71-.506-1.261-1.186-1.332l-.07-.018a1.43 1.43 0 01-.299-.07l-.05-.019a1.7 1.7 0 01-1.047-2.114 1.68 1.68 0 012.094-1.101zm-5.575 10.11c.26-.264.639-.367.994-.27.355.096.633.379.728.74.095.362-.007.748-.267 1.013-.402.41-1.053.41-1.455 0a1.062 1.062 0 010-1.482zm14.845-.294c.359-.09.738.024.992.297.254.274.344.665.237 1.025-.107.36-.396.634-.756.718-.551.128-1.1-.22-1.23-.781a1.05 1.05 0 01.757-1.26zm-.064-4.39c.314.32.49.753.49 1.206 0 .452-.176.886-.49 1.206-.315.32-.74.5-1.185.5-.444 0-.87-.18-1.184-.5a1.727 1.727 0 010-2.412 1.654 1.654 0 012.369 0zm-11.243.163c.364.484.447 1.128.218 1.691a1.665 1.665 0 01-2.188.923c-.855-.36-1.26-1.358-.907-2.228a1.68 1.68 0 011.33-1.038c.593-.08 1.183.169 1.547.652zm11.545-4.221c.368 0 .708.2.892.524.184.324.184.724 0 1.048a1.026 1.026 0 01-.892.524c-.568 0-1.03-.47-1.03-1.048 0-.579.462-1.048 1.03-1.048zm-14.358 0c.368 0 .707.2.891.524.184.324.184.724 0 1.048a1.026 1.026 0 01-.891.524c-.569 0-1.03-.47-1.03-1.048 0-.579.461-1.048 1.03-1.048zm10.031-1.475c.925 0 1.675.764 1.675 1.706s-.75 1.705-1.675 1.705-1.674-.763-1.674-1.705c0-.942.75-1.706 1.674-1.706zm-2.626-.684c.362-.082.653-.356.761-.718a1.062 1.062 0 00-.238-1.028 1.017 1.017 0 00-.996-.294c-.547.14-.881.7-.752 1.257.13.558.675.907 1.225.783zm0 16.876c.359-.087.644-.36.75-.72a1.062 1.062 0 00-.237-1.019 1.018 1.018 0 00-.985-.301 1.037 1.037 0 00-.762.717c-.108.361-.017.754.239 1.028.245.263.606.377.953.305l.043-.01zM17.19 3.5a.631.631 0 00.628-.64c0-.355-.279-.64-.628-.64a.631.631 0 00-.628.64c0 .355.28.64.628.64zm-10.38 0a.631.631 0 00.628-.64c0-.355-.28-.64-.628-.64a.631.631 0 00-.628.64c0 .355.279.64.628.64zm-5.182 7.852a.631.631 0 00-.628.64c0 .354.28.639.628.639a.63.63 0 00.627-.606l.001-.034a.62.62 0 00-.628-.64zm5.182 9.13a.631.631 0 00-.628.64c0 .355.279.64.628.64a.631.631 0 00.628-.64c0-.355-.28-.64-.628-.64zm10.38.018a.631.631 0 00-.628.64c0 .355.28.64.628.64a.631.631 0 00.628-.64c0-.355-.279-.64-.628-.64zm5.182-9.148a.631.631 0 00-.628.64c0 .354.279.639.628.639a.631.631 0 00.628-.64c0-.355-.28-.64-.628-.64zm-.384-4.992a.24.24 0 00.244-.249.24.24 0 00-.244-.249.24.24 0 00-.244.249c0 .142.122.249.244.249zM11.991.497a.24.24 0 00.245-.248A.24.24 0 0011.99 0a.24.24 0 00-.244.249c0 .133.108.236.223.247l.021.001zM2.011 6.36a.24.24 0 00.245-.249.24.24 0 00-.244-.249.24.24 0 00-.244.249.24.24 0 00.244.249zm0 11.263a.24.24 0 00-.243.248.24.24 0 00.244.249.24.24 0 00.244-.249.252.252 0 00-.244-.248zm19.995-.018a.24.24 0 00-.245.248.24.24 0 00.245.25.24.24 0 00.244-.25.252.252 0 00-.244-.248z" fill="#3859FF" fillRule="nonzero" />
    </svg>
  ),
  doubao: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Volcengine</title>
      <path d="M19.44 10.153l-2.936 11.586a.215.215 0 00.214.261h5.87a.215.215 0 00.214-.261l-2.95-11.586a.214.214 0 00-.412 0zM3.28 12.778l-2.275 8.96A.214.214 0 001.22 22h4.532a.212.212 0 00.214-.165.214.214 0 000-.097l-2.276-8.96a.214.214 0 00-.41 0z" fill="#00E5E5" />
      <path d="M7.29 5.359L3.148 21.738a.215.215 0 00.203.261h8.29a.214.214 0 00.215-.261L7.7 5.358a.214.214 0 00-.41 0z" fill="#006EFF" />
      <path d="M14.44.15a.214.214 0 00-.41 0L8.366 21.739a.214.214 0 00.214.261H19.9a.216.216 0 00.171-.078.214.214 0 00.044-.183L14.439.15z" fill="#006EFF" />
      <path d="M10.278 7.741L6.685 21.736a.214.214 0 00.214.264h7.17a.215.215 0 00.214-.264L10.688 7.741a.214.214 0 00-.41 0z" fill="#00E5E5" />
    </svg>
  ),
  qwen: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Qwen</title>
      <defs>
        <linearGradient id="qwen-gradient" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="0%" stopColor="#00055F" stopOpacity=".84" />
          <stop offset="100%" stopColor="#6F69F7" stopOpacity=".84" />
        </linearGradient>
      </defs>
      <path d="M12.604 1.34c.393.69.784 1.382 1.174 2.075a.18.18 0 00.157.091h5.552c.174 0 .322.11.446.327l1.454 2.57c.19.337.24.478.024.837-.26.43-.513.864-.76 1.3l-.367.658c-.106.196-.223.28-.04.512l2.652 4.637c.172.301.111.494-.043.77-.437.785-.882 1.564-1.335 2.34-.159.272-.352.375-.68.37-.777-.016-1.552-.01-2.327.016a.099.099 0 00-.081.05 575.097 575.097 0 01-2.705 4.74c-.169.293-.38.363-.725.364-.997.003-2.002.004-3.017.002a.537.537 0 01-.465-.271l-1.335-2.323a.09.09 0 00-.083-.049H4.982c-.285.03-.553-.001-.805-.092l-1.603-2.77a.543.543 0 01-.002-.54l1.207-2.12a.198.198 0 000-.197 550.951 550.951 0 01-1.875-3.272l-.79-1.395c-.16-.31-.173-.496.095-.965.465-.813.927-1.625 1.387-2.436.132-.234.304-.334.584-.335a338.3 338.3 0 012.589-.001.124.124 0 00.107-.063l2.806-4.895a.488.488 0 01.422-.246c.524-.001 1.053 0 1.583-.006L11.704 1c.341-.003.724.032.9.34zm-3.432.403a.06.06 0 00-.052.03L6.254 6.788a.157.157 0 01-.135.078H3.253c-.056 0-.07.025-.041.074l5.81 10.156c.025.042.013.062-.034.063l-2.795.015a.218.218 0 00-.2.116l-1.32 2.31c-.044.078-.021.118.068.118l5.716.008c.046 0 .08.02.104.061l1.403 2.454c.046.081.092.082.139 0l5.006-8.76.783-1.382a.055.055 0 01.096 0l1.424 2.53a.122.122 0 00.107.062l2.763-.02a.04.04 0 00.035-.02.041.041 0 000-.04l-2.9-5.086a.108.108 0 010-.113l.293-.507 1.12-1.977c.024-.041.012-.062-.035-.062H9.2c-.059 0-.073-.026-.043-.077l1.434-2.505a.107.107 0 000-.114L9.225 1.774a.06.06 0 00-.053-.031zm6.29 8.02c.046 0 .058.02.034.06l-.832 1.465-2.613 4.585a.056.056 0 01-.05.029.058.058 0 01-.05-.029L8.498 9.841c-.02-.034-.01-.052.028-.054l.216-.012 6.722-.012z" fill="url(#qwen-gradient)" fillRule="nonzero" />
    </svg>
  ),
  kimi: (
    <svg fill="currentColor" viewBox="0 0 24 24" width="32" height="32">
      <title>MoonshotAI</title>
      <path d="M1.052 16.916l9.539 2.552a21.007 21.007 0 00.06 2.033l5.956 1.593a11.997 11.997 0 01-5.586.865l-.18-.016-.044-.004-.084-.009-.094-.01a11.605 11.605 0 01-.157-.02l-.107-.014-.11-.016a11.962 11.962 0 01-.32-.051l-.042-.008-.075-.013-.107-.02-.07-.015-.093-.019-.075-.016-.095-.02-.097-.023-.094-.022-.068-.017-.088-.022-.09-.024-.095-.025-.082-.023-.109-.03-.062-.02-.084-.025-.093-.028-.105-.034-.058-.019-.08-.026-.09-.031-.066-.024a6.293 6.293 0 01-.044-.015l-.068-.025-.101-.037-.057-.022-.08-.03-.087-.035-.088-.035-.079-.032-.095-.04-.063-.028-.063-.027a5.655 5.655 0 01-.041-.018l-.066-.03-.103-.047-.052-.024-.096-.046-.062-.03-.084-.04-.086-.044-.093-.047-.052-.027-.103-.055-.057-.03-.058-.032a6.49 6.49 0 01-.046-.026l-.094-.053-.06-.034-.051-.03-.072-.041-.082-.05-.093-.056-.052-.032-.084-.053-.061-.039-.079-.05-.07-.047-.053-.035a7.785 7.785 0 01-.054-.036l-.044-.03-.044-.03a6.066 6.066 0 01-.04-.028l-.057-.04-.076-.054-.069-.05-.074-.054-.056-.042-.076-.057-.076-.059-.086-.067-.045-.035-.064-.052-.074-.06-.089-.073-.046-.039-.046-.039a7.516 7.516 0 01-.043-.037l-.045-.04-.061-.053-.07-.062-.068-.06-.062-.058-.067-.062-.053-.05-.088-.084a13.28 13.28 0 01-.099-.097l-.029-.028-.041-.042-.069-.07-.05-.051-.05-.053a6.457 6.457 0 01-.168-.179l-.08-.088-.062-.07-.071-.08-.042-.049-.053-.062-.058-.068-.046-.056a7.175 7.175 0 01-.027-.033l-.045-.055-.066-.082-.041-.052-.05-.064-.02-.025a11.99 11.99 0 01-1.44-2.402zm-1.02-5.794l11.353 3.037a20.468 20.468 0 00-.469 2.011l10.817 2.894a12.076 12.076 0 01-1.845 2.005L.657 15.923l-.016-.046-.035-.104a11.965 11.965 0 01-.05-.153l-.007-.023a11.896 11.896 0 01-.207-.741l-.03-.126-.018-.08-.021-.097-.018-.081-.018-.09-.017-.084-.018-.094c-.026-.141-.05-.283-.071-.426l-.017-.118-.011-.083-.013-.102a12.01 12.01 0 01-.019-.161l-.005-.047a12.12 12.12 0 01-.034-2.145zm1.593-5.15l11.948 3.196c-.368.605-.705 1.231-1.01 1.875l11.295 3.022c-.142.82-.368 1.612-.668 2.365l-11.55-3.09L.124 10.26l.015-.1.008-.049.01-.067.015-.087.018-.098c.026-.148.056-.295.088-.442l.028-.124.02-.085.024-.097c.022-.09.045-.18.07-.268l.028-.102.023-.083.03-.1.025-.082.03-.096.026-.082.031-.095a11.896 11.896 0 011.01-2.232zm4.442-4.4L17.352 4.59a20.77 20.77 0 00-1.688 1.721l7.823 2.093c.267.852.442 1.744.513 2.665L2.106 5.213l.045-.065.027-.04.04-.055.046-.065.055-.076.054-.072.064-.086.05-.065.057-.073.055-.07.06-.074.055-.069.065-.077.054-.066.066-.077.053-.06.072-.082.053-.06.067-.074.054-.058.073-.078.058-.06.063-.067.168-.17.1-.098.059-.056.076-.071a12.084 12.084 0 012.272-1.677zM12.017 0h.097l.082.001.069.001.054.002.068.002.046.001.076.003.047.002.06.003.054.002.087.005.105.007.144.011.088.007.044.004.077.008.082.008.047.005.102.012.05.006.108.014.081.01.042.006.065.01.207.032.07.012.065.011.14.026.092.018.11.022.046.01.075.016.041.01L14.7.3l.042.01.065.015.049.012.071.017.096.024.112.03.113.03.113.032.05.015.07.02.078.024.073.023.05.016.05.016.076.025.099.033.102.036.048.017.064.023.093.034.11.041.116.045.1.04.047.02.06.024.041.018.063.026.04.018.057.025.11.048.1.046.074.035.075.036.06.028.092.046.091.045.102.052.053.028.049.026.046.024.06.033.041.022.052.029.088.05.106.06.087.051.057.034.053.032.096.059.088.055.098.062.036.024.064.041.084.056.04.027.062.042.062.043.023.017c.054.037.108.075.161.114l.083.06.065.048.056.043.086.065.082.064.04.03.05.041.086.069.079.065.085.071c.712.6 1.353 1.283 1.909 2.031L7.222.994l.062-.027.065-.028.081-.034.086-.035c.113-.045.227-.09.341-.131l.096-.035.093-.033.084-.03.096-.031c.087-.03.176-.058.264-.085l.091-.027.086-.025.102-.03.085-.023.1-.026L9.04.37l.09-.023.091-.022.095-.022.09-.02.098-.021.091-.02.095-.018.092-.018.1-.018.091-.016.098-.017.092-.014.097-.015.092-.013.102-.013.091-.012.105-.012.09-.01.105-.01c.093-.01.186-.018.28-.024l.106-.008.09-.005.11-.006.093-.004.1-.004.097-.002.099-.002.197-.002z" />
    </svg>
  ),
  deepseek: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>DeepSeek</title>
      <path d="M23.748 4.482c-.254-.124-.364.113-.512.234-.051.039-.094.09-.137.136-.372.397-.806.657-1.373.626-.829-.046-1.537.214-2.163.848-.133-.782-.575-1.248-1.247-1.548-.352-.156-.708-.311-.955-.65-.172-.241-.219-.51-.305-.774-.055-.16-.11-.323-.293-.35-.2-.031-.278.136-.356.276-.313.572-.434 1.202-.422 1.84.027 1.436.633 2.58 1.838 3.393.137.093.172.187.129.323-.082.28-.18.552-.266.833-.055.179-.137.217-.329.14a5.526 5.526 0 01-1.736-1.18c-.857-.828-1.631-1.742-2.597-2.458a11.365 11.365 0 00-.689-.471c-.985-.957.13-1.743.388-1.836.27-.098.093-.432-.779-.428-.872.004-1.67.295-2.687.684a3.055 3.055 0 01-.465.137 9.597 9.597 0 00-2.883-.102c-1.885.21-3.39 1.102-4.497 2.623C.082 8.606-.231 10.684.152 12.85c.403 2.284 1.569 4.175 3.36 5.653 1.858 1.533 3.997 2.284 6.438 2.14 1.482-.085 3.133-.284 4.994-1.86.47.234.962.327 1.78.397.63.059 1.236-.03 1.705-.128.735-.156.684-.837.419-.961-2.155-1.004-1.682-.595-2.113-.926 1.096-1.296 2.746-2.642 3.392-7.003.05-.347.007-.565 0-.845-.004-.17.035-.237.23-.256a4.173 4.173 0 001.545-.475c1.396-.763 1.96-2.015 2.093-3.517.02-.23-.004-.467-.247-.588zM11.581 18c-2.089-1.642-3.102-2.183-3.52-2.16-.392.024-.321.471-.235.763.09.288.207.486.371.739.114.167.192.416-.113.603-.673.416-1.842-.14-1.897-.167-1.361-.802-2.5-1.86-3.301-3.307-.774-1.393-1.224-2.887-1.298-4.482-.02-.386.093-.522.477-.592a4.696 4.696 0 011.529-.039c2.132.312 3.946 1.265 5.468 2.774.868.86 1.525 1.887 2.202 2.891.72 1.066 1.494 2.082 2.48 2.914.348.292.625.514.891.677-.802.09-2.14.11-3.054-.614zm1-6.44a.306.306 0 01.415-.287.302.302 0 01.2.288.306.306 0 01-.31.307.303.303 0 01-.304-.308zm3.11 1.596c-.2.081-.399.151-.59.16a1.245 1.245 0 01-.798-.254c-.274-.23-.47-.358-.552-.758a1.73 1.73 0 01.016-.588c.07-.327-.008-.537-.239-.727-.187-.156-.426-.199-.688-.199a.559.559 0 01-.254-.078c-.11-.054-.2-.19-.114-.358.028-.054.16-.186.192-.21.356-.202.767-.136 1.146.016.352.144.618.408 1.001.782.391.451.462.576.685.914.176.265.336.537.445.848.067.195-.019.354-.25.452z" fill="#4D6BFE" />
    </svg>
  ),
  minimax: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Minimax</title>
      <defs>
        <linearGradient id="minimax-gradient-card" x1="0%" x2="100.182%" y1="50.057%" y2="50.057%">
          <stop offset="0%" stopColor="#E2167E" />
          <stop offset="100%" stopColor="#FE603C" />
        </linearGradient>
      </defs>
      <path d="M16.278 2c1.156 0 2.093.927 2.093 2.07v12.501a.74.74 0 00.744.709.74.74 0 00.743-.709V9.099a2.06 2.06 0 012.071-2.049A2.06 2.06 0 0124 9.1v6.561a.649.649 0 01-.652.645.649.649 0 01-.653-.645V9.1a.762.762 0 00-.766-.758.762.762 0 00-.766.758v7.472a2.037 2.037 0 01-2.048 2.026 2.037 2.037 0 01-2.048-2.026v-12.5a.785.785 0 00-.788-.753.785.785 0 00-.789.752l-.001 15.904A2.037 2.037 0 0113.441 22a2.037 2.037 0 01-2.048-2.026V18.04c0-.356.292-.645.652-.645.36 0 .652.289.652.645v1.934c0 .263.142.506.372.638.23.131.514.131.744 0a.734.734 0 00.372-.638V4.07c0-1.143.937-2.07 2.093-2.07zm-5.674 0c1.156 0 2.093.927 2.093 2.07v11.523a.648.648 0 01-.652.645.648.648 0 01-.652-.645V4.07a.785.785 0 00-.789-.78.785.785 0 00-.789.78v14.013a2.06 2.06 0 01-2.07 2.048 2.06 2.06 0 01-2.071-2.048V9.1a.762.762 0 00-.766-.758.762.762 0 00-.766.758v3.8a2.06 2.06 0 01-2.071 2.049A2.06 2.06 0 010 12.9v-1.378c0-.357.292-.646.652-.646.36 0 .653.29.653.646V12.9c0 .418.343.757.766.757s.766-.339.766-.757V9.099a2.06 2.06 0 012.07-2.048 2.06 2.06 0 012.071 2.048v8.984c0 .419.343.758.767.758.423 0 .766-.339.766-.758V4.07c0-1.143.937-2.07 2.093-2.07z" fill="url(#minimax-gradient-card)" fillRule="nonzero" />
    </svg>
  ),
  claude: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Claude</title>
      <path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128H9.2l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L0 11.784l.055-.352.48-.321.686.06 1.52.103 2.278.158 1.652.097 2.449.255h.389l.055-.157-.134-.098-.103-.097-2.358-1.596-2.552-1.688-1.336-.972-.724-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a2.97 2.97 0 01-.104-.729L6.283.134 6.696 0l.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.091.255h.158V9.01l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.091.395-.328.807-1.969.486-2.309.462-3.439.813-.042.03.049.061 1.549.146.662.036h1.622l3.02.225.79.522.474.638-.079.485-1.215.62-1.64-.389-3.829-.91-1.312-.329h-.182v.11l1.093 1.068 2.006 1.81 2.509 2.33.127.578-.322.455-.34-.049-2.205-1.657-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.08-.17.353-.608.213-.668-.122-1.374-1.925-1.415-2.167-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.476.389-1.924.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.18 2.945-1.726 1.845-.414.164-.717-.37.067-.662.401-.589 2.388-3.036 1.44-1.882.93-1.086-.006-.158h-.055L4.132 18.56l-1.13.146-.487-.456.061-.746.231-.243 1.908-1.312-.006.006z" fill="#D97757" fillRule="nonzero" />
    </svg>
  ),
  volcengine: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Volcengine</title>
      <defs>
        <linearGradient id="volc-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1664FF" />
          <stop offset="100%" stopColor="#1EA2FF" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="11" fill="url(#volc-grad)" />
      <path d="M7 8.5l5 3 5-3-5-3-5 3zm0 7l5-3v-3l-5 3v3zm10 0v-3l-5 3v3l5-3z" fill="#fff" />
    </svg>
  ),
  gemini: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Gemini</title>
      <defs>
        <linearGradient id="lobe-icons-gemini-fill" x1="0%" x2="68.73%" y1="100%" y2="30.395%">
          <stop offset="0%" stopColor="#1C7DFF" />
          <stop offset="52.021%" stopColor="#1C69FF" />
          <stop offset="100%" stopColor="#F0DCD6" />
        </linearGradient>
      </defs>
      <path d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12" fill="url(#lobe-icons-gemini-fill)" fillRule="nonzero" />
    </svg>
  ),
  openai: (
    <svg fill="currentColor" viewBox="0 0 24 24" width="32" height="32">
      <title>OpenAI</title>
      <path d="M21.55 10.004a5.416 5.416 0 00-.478-4.501c-1.217-2.09-3.662-3.166-6.05-2.66A5.59 5.59 0 0010.831 1C8.39.995 6.224 2.546 5.473 4.838A5.553 5.553 0 001.76 7.496a5.487 5.487 0 00.691 6.5 5.416 5.416 0 00.477 4.502c1.217 2.09 3.662 3.165 6.05 2.66A5.586 5.586 0 0013.168 23c2.443.006 4.61-1.546 5.361-3.84a5.553 5.553 0 003.715-2.66 5.488 5.488 0 00-.693-6.497v.001zm-8.381 11.558a4.199 4.199 0 01-2.675-.954c.034-.018.093-.05.132-.074l4.44-2.53a.71.71 0 00.364-.623v-6.176l1.877 1.069c.02.01.033.029.036.05v5.115c-.003 2.274-1.87 4.118-4.174 4.123zM4.192 17.78a4.059 4.059 0 01-.498-2.763c.032.02.09.055.131.078l4.44 2.53c.225.13.504.13.73 0l5.42-3.088v2.138a.068.068 0 01-.027.057L9.9 19.288c-1.999 1.136-4.552.46-5.707-1.51h-.001zM3.023 8.216A4.15 4.15 0 015.198 6.41l-.002.151v5.06a.711.711 0 00.364.624l5.42 3.087-1.876 1.07a.067.067 0 01-.063.005l-4.489-2.559c-1.995-1.14-2.679-3.658-1.53-5.63h.001zm15.417 3.54l-5.42-3.088L14.896 7.6a.067.067 0 01.063-.006l4.489 2.557c1.998 1.14 2.683 3.662 1.529 5.633a4.163 4.163 0 01-2.174 1.807V12.38a.71.71 0 00-.363-.623zm1.867-2.773a6.04 6.04 0 00-.132-.078l-4.44-2.53a.731.731 0 00-.729 0l-5.42 3.088V7.325a.068.068 0 01.027-.057L14.1 4.713c2-1.137 4.555-.46 5.707 1.513.487.833.664 1.809.499 2.757h.001zm-11.741 3.81l-1.877-1.068a.065.065 0 01-.036-.051V6.559c.001-2.277 1.873-4.122 4.181-4.12.976 0 1.92.338 2.671.954-.034.018-.092.05-.131.073l-4.44 2.53a.71.71 0 00-.365.623l-.003 6.173v.002zm1.02-2.168L12 9.25l2.414 1.375v2.75L12 14.75l-2.415-1.375v-2.75z" />
    </svg>
  ),
  grok: (
    <svg fill="currentColor" viewBox="0 0 24 24" width="32" height="32">
      <title>Grok</title>
      <path d="M6.469 8.776L16.512 23h-4.464L2.005 8.776H6.47zm-.004 7.9l2.233 3.164L6.467 23H2l4.465-6.324zM22 2.582V23h-3.659V7.764L22 2.582zM22 1l-9.952 14.095-2.233-3.163L17.533 1H22z" />
    </svg>
  ),
  midjourney: (
    <svg fill="currentColor" viewBox="0 0 24 24" width="32" height="32">
      <title>Midjourney</title>
      <path d="M22.369 17.676c-1.387 1.259-3.17 2.378-5.332 3.417.044.03.086.057.13.083l.018.01.019.012c.216.123.42.184.641.184.222 0 .426-.061.642-.184l.018-.011.019-.011c.14-.084.266-.178.492-.366l.178-.148c.279-.232.426-.342.625-.456.304-.174.612-.266.949-.266.337 0 .645.092.949.266l.023.014c.188.109.334.219.602.442l.178.148c.221.184.346.278.483.36l.028.017.018.01c.21.12.407.181.62.185h.022a.31.31 0 110 .618c-.337 0-.645-.092-.95-.266a3.137 3.137 0 01-.09-.054l-.022-.014-.022-.013-.02-.014a5.356 5.356 0 01-.49-.377l-.159-.132a3.836 3.836 0 00-.483-.36l-.027-.017-.019-.01a1.256 1.256 0 00-.641-.185c-.222 0-.426.061-.641.184l-.02.011-.018.011c-.14.084-.266.178-.492.366l-.158.132a5.125 5.125 0 01-.51.39l-.022.014-.022.014-.09.054a1.868 1.868 0 01-.95.266c-.337 0-.644-.092-.949-.266a3.137 3.137 0 01-.09-.054l-.022-.014-.022-.013-.026-.017a4.881 4.881 0 01-.425-.325.308.308 0 01-.12-.1l-.098-.081a3.836 3.836 0 00-.483-.36l-.027-.017-.019-.01a1.256 1.256 0 00-.641-.185c-.222 0-.426.061-.642.184l-.018.011-.019.011c-.14.084-.266.178-.492.366l-.158.132a5.125 5.125 0 01-.51.39l-.023.014-.022.014-.09.054A1.868 1.868 0 0112 22c-.337 0-.645-.092-.949-.266a3.137 3.137 0 01-.09-.054l-.022-.014-.022-.013-.021-.014a5.356 5.356 0 01-.49-.377l-.158-.132a3.836 3.836 0 00-.483-.36l-.028-.017-.018-.01a1.256 1.256 0 00-.642-.185c-.221 0-.425.061-.641.184l-.019.011-.018.011c-.141.084-.266.178-.492.366l-.158.132a5.125 5.125 0 01-.511.39l-.022.014-.022.014-.09.054a1.868 1.868 0 01-.986.264c-.746-.09-1.319-.38-1.89-.866l-.035-.03c-.047-.041-.118-.106-.192-.174l-.196-.181-.107-.1-.011-.01a1.531 1.531 0 00-.336-.253.313.313 0 00-.095-.03h-.005c-.119.022-.238.059-.361.11a.308.308 0 01-.077.061l-.008.005a.309.309 0 01-.126.034 5.66 5.66 0 00-.774.518l-.416.324-.055.043a6.542 6.542 0 01-.324.236c-.305.207-.552.315-.8.315a.31.31 0 01-.01-.618h.01c.09 0 .235-.062.438-.198l.04-.027c.077-.054.163-.117.27-.199l.385-.301.06-.047c.268-.206.506-.373.73-.505l-.633-1.21a.309.309 0 01.254-.451l20.287-1.305a.309.309 0 01.228.537zm-1.118.14L2.369 19.03l.423.809c.128-.045.256-.078.388-.1a.31.31 0 01.052-.005c.132 0 .26.032.386.093.153.073.294.179.483.35l.016.015.092.086.144.134.097.089c.065.06.125.114.16.144.485.418.948.658 1.554.736h.011a1.25 1.25 0 00.6-.172l.021-.011.019-.011.018-.011c.141-.084.266-.178.492-.366l.178-.148c.279-.232.426-.342.625-.456.305-.174.612-.266.95-.266.336 0 .644.092.948.266l.023.014c.188.109.335.219.603.442l.177.148c.222.184.346.278.484.36l.027.017.019.01c.215.124.42.185.641.185.222 0 .426-.061.641-.184l.019-.011.018-.011c.141-.084.267-.178.493-.366l.177-.148c.28-.232.427-.342.626-.456.304-.174.612-.266.949-.266.337 0 .644.092.949.266l.025.015c.187.109.334.22.603.443 1.867-.878 3.448-1.811 4.73-2.832l.02-.016zM3.653 2.026C6.073 3.06 8.69 4.941 10.8 7.258c2.46 2.7 4.109 5.828 4.637 9.149a.31.31 0 01-.421.335c-2.348-.945-4.54-1.258-6.59-1.02-1.739.2-3.337.792-4.816 1.703-.294.182-.62-.182-.405-.454 1.856-2.355 2.581-4.99 2.343-7.794-.195-2.292-1.031-4.61-2.284-6.709a.31.31 0 01.388-.442zM10.04 4.45c1.778.543 3.892 2.102 5.782 4.243 1.984 2.248 3.552 4.934 4.347 7.582a.31.31 0 01-.401.38l-.022-.01-.386-.154a10.594 10.594 0 00-.291-.112l-.016-.006c-.68-.247-1.199-.291-1.944-.101a.31.31 0 01-.375-.218C15.378 11.123 13.073 7.276 9.775 5c-.291-.201-.072-.653.266-.55zM4.273 2.996l.008.015c1.028 1.94 1.708 4.031 1.885 6.113.213 2.513-.31 4.906-1.673 7.092l-.02.031.003-.001c1.198-.581 2.47-.969 3.825-1.132l.055-.006c1.981-.23 4.083.029 6.309.837l.066.025-.007-.039c-.593-2.95-2.108-5.737-4.31-8.179l-.07-.078c-1.785-1.96-3.944-3.6-6.014-4.65l-.057-.028zm7.92 3.238l.048.048c2.237 2.295 3.885 5.431 4.974 9.191l.038.132.022-.004c.71-.133 1.284-.063 1.963.18l.027.01.066.024.046.018-.025-.073c-.811-2.307-2.208-4.62-3.936-6.594l-.058-.065c-1.02-1.155-2.103-2.132-3.15-2.856l-.015-.011z" />
    </svg>
  ),
  suno: (
    <svg fill="currentColor" viewBox="0 0 24 24" width="32" height="32">
      <title>Suno</title>
      <path d="M16.5 0C20.642 0 24 5.373 24 12h-9c0 6.627-3.358 12-7.5 12C3.358 24 0 18.627 0 12h9c0-6.627 3.358-12 7.5-12z" />
    </svg>
  ),
  cohere: (
    <svg viewBox="0 0 24 24" width="32" height="32">
      <title>Cohere</title>
      <path clipRule="evenodd" d="M8.128 14.099c.592 0 1.77-.033 3.398-.703 1.897-.781 5.672-2.2 8.395-3.656 1.905-1.018 2.74-2.366 2.74-4.18A4.56 4.56 0 0018.1 1H7.549A6.55 6.55 0 001 7.55c0 3.617 2.745 6.549 7.128 6.549z" fill="#39594D" fillRule="evenodd" />
      <path clipRule="evenodd" d="M9.912 18.61a4.387 4.387 0 012.705-4.052l3.323-1.38c3.361-1.394 7.06 1.076 7.06 4.715a5.104 5.104 0 01-5.105 5.104l-3.597-.001a4.386 4.386 0 01-4.386-4.387z" fill="#D18EE2" fillRule="evenodd" />
      <path d="M4.776 14.962A3.775 3.775 0 001 18.738v.489a3.776 3.776 0 007.551 0v-.49a3.775 3.775 0 00-3.775-3.775z" fill="#FF7759" />
    </svg>
  ),
};

const getModelLogo = (model) => {
  // 优先使用模型配置的自定义图标
  if (model?.icon) {
    return <img src={model.icon} alt={model.model_name || ''} style={{ width: 32, height: 32, objectFit: 'contain' }} />;
  }
  const modelName = model?.model_name || (typeof model === 'string' ? model : '');
  if (!modelName) return modelLogos.glm;
  const name = (typeof modelName === 'string' ? modelName : '').toLowerCase();
  
  if (name.includes('glm') || name.includes('zhipu') || name.includes('智谱')) return modelLogos.glm;
  if (name.includes('doubao') || name.includes('豆包') || name.includes('字节')) return modelLogos.doubao;
  if (name.includes('qwen') || name.includes('通义') || name.includes('aliyun')) return modelLogos.qwen;
  if (name.includes('kimi') || name.includes('moonshot') || name.includes('月之暗面')) return modelLogos.kimi;
  if (name.includes('seed') || name.includes('volcengine') || name.includes('火山') || name.includes('xrtoken')) return modelLogos.volcengine;
  if (name.includes('deepseek')) return modelLogos.deepseek;
  if (name.includes('minimax')) return modelLogos.minimax;
  if (name.includes('claude')) return modelLogos.claude;
  if (name.includes('gemini')) return modelLogos.gemini;
  if (name.includes('gpt') || name.includes('openai') || name.includes('chatgpt')) return modelLogos.openai;
  if (name.includes('grok')) return modelLogos.grok;
  if (name.includes('midjourney')) return modelLogos.midjourney;
  if (name.includes('suno')) return modelLogos.suno;
  if (name.includes('cohere')) return modelLogos.cohere;
  
  return modelLogos.glm;
};

const ModelSquare = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState([]);
  const [hotModels, setHotModels] = useState([]);
  const [types, setTypes] = useState([]);
  const [useCases, setUseCases] = useState([]);
  const [userTrainedModels, setUserTrainedModels] = useState([]); // 用户训练模型
  const [trainedTotal, setTrainedTotal] = useState(0); // 训练模型总数
  const [trainedPage, setTrainedPage] = useState(1); // 训练模型当前页
  const [trainedPageSize, setTrainedPageSize] = useState(8); // 训练模型每页数量
  const [presets, setPresets] = useState([]); // 预设列表

  const [searchText, setSearchText] = useState('');
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedUseCases, setSelectedUseCases] = useState([]);
  const [hotPage, setHotPage] = useState(1);
  const [allPage, setAllPage] = useState(1);
  const [hotPageSize, setHotPageSize] = useState(8);
  const [allPageSize, setAllPageSize] = useState(8);
  const [hotSortField, setHotSortField] = useState('default');
  const [hotSortOrder, setHotSortOrder] = useState('asc');
  const [allSortField, setAllSortField] = useState('default');
  const [allSortOrder, setAllSortOrder] = useState('asc');
  const [bgImage, setBgImage] = useState(null); // 初始为 null，有配置时再设置
  const [typedText, setTypedText] = useState(''); // 打字机效果
  const [subtitleVisible, setSubtitleVisible] = useState(false); // 副标题闪现
  const [allModelsForCount, setAllModelsForCount] = useState([]); // 保存所有模型用于分类计数
  const [activeTab, setActiveTab] = useState('all'); // 'all' | 'my-training'

  const fullTitle = t('model_square_title');

  // 收集所有唯一的场景标签并分配不重复的颜色
  const useCaseColorMap = useMemo(() => {
    // 预定义颜色表
    const baseColorMap = {
      '对话助手': { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      '内容创作': { bg: '#e6f4ff', border: '#91caff', text: '#1890ff' },
      '代码生成': { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
      '长文本处理': { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
      'RAG': { bg: '#fff1f0', border: '#ffccc7', text: '#ff4d4f' },
      '翻译': { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      '图像生成': { bg: '#fff0f6', border: '#ffadd2', text: '#eb2f96' },
      '视频生成': { bg: '#e6f7ff', border: '#91caff', text: '#1890ff' },
      '语音识别': { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      '智能客服': { bg: '#e6fffb', border: '#87e8de', text: '#13c2c2' },
      '角色扮演': { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
      '数据分析': { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
      '知识问答': { bg: '#e6f7ff', border: '#91caff', text: '#1890ff' },
      '文案撰写': { bg: '#fff0f6', border: '#ffadd2', text: '#eb2f96' },
      '摘要生成': { bg: '#fff1f0', border: '#ffccc7', text: '#ff4d4f' },
      '数学解题': { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      '多模态': { bg: '#e6fffb', border: '#87e8de', text: '#13c2c2' },
      '搜索增强': { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
      '文本分类': { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
      '情感分析': { bg: '#fff0f6', border: '#ffadd2', text: '#eb2f96' },
      '信息抽取': { bg: '#e6f4ff', border: '#91caff', text: '#1890ff' },
      '问答系统': { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      '创意写作': { bg: '#fff1f0', border: '#ffccc7', text: '#ff4d4f' },
      '代码补全': { bg: '#e6fffb', border: '#87e8de', text: '#13c2c2' },
      'API开发': { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
      '数据处理': { bg: '#e6f7ff', border: '#91caff', text: '#1890ff' },
      '学术研究': { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
    };

    // 额外颜色池（用于预定义颜色表中没有的标签）
    const extraColors = [
      { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      { bg: '#e6f4ff', border: '#91caff', text: '#1890ff' },
      { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
      { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
      { bg: '#fff1f0', border: '#ffccc7', text: '#ff4d4f' },
      { bg: '#fff0f6', border: '#ffadd2', text: '#eb2f96' },
      { bg: '#e6fffb', border: '#87e8de', text: '#13c2c2' },
      { bg: '#e6f7ff', border: '#91caff', text: '#0958d9' },
    ];

    // 收集所有唯一的场景标签
    const allTags = new Set();
    models.forEach(model => {
      if (model.use_case) {
        model.use_case.split(',').forEach(tag => {
          allTags.add(tag.trim());
        });
      }
    });

    // 已使用的颜色索引
    const usedColorIndices = new Set();

    // 构建最终的颜色映射
    const colorMap = { ...baseColorMap };

    // 先为预定义颜色表中的标签标记已使用的颜色
    Object.keys(baseColorMap).forEach(tag => {
      const color = baseColorMap[tag];
      const idx = extraColors.findIndex(c => c.bg === color.bg);
      if (idx !== -1) usedColorIndices.add(idx);
    });

    // 为未在预定义表中的标签分配未使用的颜色
    allTags.forEach(tag => {
      if (!colorMap[tag]) {
        // 找到一个未使用的颜色
        let colorIdx = 0;
        for (let i = 0; i < extraColors.length; i++) {
          if (!usedColorIndices.has(i)) {
            colorIdx = i;
            usedColorIndices.add(i);
            break;
          }
        }
        colorMap[tag] = extraColors[colorIdx];
      }
    });

    return colorMap;
  }, [models]);

  // 打字机动画效果
  useEffect(() => {
    let index = 0;
    setTypedText('');
    setSubtitleVisible(false);
    
    // 打字间隔
    const typeInterval = setInterval(() => {
      if (index <= fullTitle.length) {
        setTypedText(fullTitle.slice(0, index));
        index++;
      } else {
        clearInterval(typeInterval);
        // 打字完成，闪现副标题
        setTimeout(() => setSubtitleVisible(true), 200);
      }
    }, 120);
    
    return () => clearInterval(typeInterval);
  }, []);

  // 获取背景图配置
  useEffect(() => {
    const fetchBgConfig = async () => {
      try {
        const res = await configAPI.getConfigs();
        console.log('Config API response:', res);
        if (res.code === 0) {
          const bgConfig = res.data?.list?.find(c => c.config_key === 'model_square_bg');
          console.log('Background config:', bgConfig);
          if (bgConfig && bgConfig.config_value) {
            // 使用 getImageUrl 处理图片 URL，自动添加域名
            setBgImage(getImageUrl(bgConfig.config_value));
          }
        }
      } catch (e) {
        console.log('获取背景图配置失败:', e);
      }
    };
    fetchBgConfig();
  }, []);

  useEffect(() => {
    // 检查 URL 参数
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if (tab === 'my-training') {
      setActiveTab('my-training');
    }
  }, []);

  useEffect(() => {
    fetchFilters();
    fetchHotModels();
    if (activeTab === 'all') {
      fetchModels();
    } else {
      fetchMyTrainedModels();
    }
  }, [activeTab]);

  // 获取我的训练模型
  const fetchMyTrainedModels = async () => {
    setLoading(true);
    try {
      const params = { page: trainedPage, page_size: trainedPageSize };
      if (searchText) params.search = searchText;
      const res = await userModelConfigAPI.getMyConfigs(params);
      if (res.code === 0 && res.data.items) {
        setUserTrainedModels(res.data.items);
        setTrainedTotal(res.data.total || 0);
      }
    } catch (e) {
      console.error('获取我的训练模型失败');
    } finally {
      setLoading(false);
    }
  };

  // 加载预设列表
  const fetchPresets = async () => {
    try {
      const res = await presetAPI.getPublicPresets();
      if (res.code === 0 && res.data) {
        const items = res.data.items || res.data.list || [];
        setPresets(items.map(p => ({
          ...p,
          systemPrompt: p.prompt || p.system_prompt || p.content || '',
        })));
      }
    } catch (err) {
      console.error('加载预设失败:', err);
    }
  };

  // 监听筛选条件变化，自动搜索（排除初始加载）
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (activeTab === 'all') {
      fetchModels();
    } else {
      fetchMyTrainedModels();
    }
  }, [searchText, selectedTypes, selectedUseCases]);

  // 监听 My Training 分页变化
  useEffect(() => {
    if (activeTab === 'my-training') {
      fetchMyTrainedModels();
    }
  }, [trainedPage, trainedPageSize]);

  // 加载预设列表
  useEffect(() => {
    fetchPresets();
  }, []);

  // 固定类型映射
  const TYPE_MAPPING = {
    text: { en: 'Text', cn: '对话' },
    image: { en: 'Image', cn: '图像' },
    embeddings: { en: 'Embeddings', cn: '嵌入' },
    audio: { en: 'Audio', cn: '语音' },
    video: { en: 'Video', cn: '视频' },
    rerank: { en: 'Rerank', cn: '重排序' },
    speech: { en: 'Speech', cn: '语音合成' },
    transcription: { en: 'Transcription', cn: '语音识别' },
  };
  const FIXED_TYPES = Object.keys(TYPE_MAPPING);

  const fetchFilters = async () => {
    try {
      // 从API获取模型类型和应用场景
      const [typesRes, useCasesRes] = await Promise.all([
        modelAPI.getModelTypes(),
        modelAPI.getUseCases()
      ]);
      
      // 使用固定类型列表
      setTypes(FIXED_TYPES);
      
      // 处理应用场景 - 从API获取数据并分割、去重
      if (useCasesRes.code === 0 && useCasesRes.data.list && useCasesRes.data.list.length > 0) {
        // 从原始数据中提取所有标签并去重
        const tagSet = new Set();
        useCasesRes.data.list.forEach(uc => {
          if (typeof uc === 'string') {
            uc.split(',').forEach(tag => {
              const trimmed = tag.trim();
              if (trimmed) tagSet.add(trimmed);
            });
          }
        });
        setUseCases([...tagSet]);
      } else {
        setUseCases([]);
      }
    } catch (e) {
      // 如果API失败，使用固定类型
      setTypes(FIXED_TYPES);
      setUseCases([]);
    }
  };

  // 获取热门模型列表
  const fetchHotModels = async () => {
    try {
      const res = await modelAPI.getHotModels();
      if (res.code === 0 && res.data.list) {
        setHotModels(res.data.list);
      }
    } catch (e) {
      console.log('获取热门模型失败');
    }
  };

  const fetchModels = async () => {
    setLoading(true);
    try {
      const params = {};
      if (searchText) params.search = searchText;
      if (selectedTypes.length > 0) params.type = selectedTypes.join(',');
      if (selectedUseCases.length > 0) params.use_case = selectedUseCases.join(',');
      const res = await modelAPI.getSquareModels(params);
      if (res.code === 0) {
        setModels(res.data.list || []);
        // 同时保存所有模型用于分类计数（只在初始加载时保存）
        if (!searchText && selectedTypes.length === 0 && selectedUseCases.length === 0) {
          setAllModelsForCount(res.data.list || []);
        }
      }
    } catch (e) {
      console.error('获取模型列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (activeTab === 'all') {
      fetchModels();
    } else {
      fetchMyTrainedModels();
    }
  };

  // 继续训练 - 跳转到 Playground 并加载配置
  const handleContinueTraining = (config, matchedPreset) => {
    // 保存配置到 localStorage
    const configData = {
      configId: config.id,
      configName: config.name,
      modelName: config.model_name,
      parameters: config.parsed_params || JSON.parse(config.parameters || '{}'),
      // 保存预设信息
      presetName: matchedPreset?.name || '',
      presetSystemPrompt: matchedPreset?.systemPrompt || '',
      presetId: matchedPreset?.id || '',
    };
    localStorage.setItem('playground_trained_config', JSON.stringify(configData));
    navigate('/dashboard/model-training');
  };

  // 删除训练配置
  const handleDeleteConfig = async (config) => {
    try {
      const response = await userModelConfigAPI.deleteConfig(config.id);
      if (response.code === 0) {
        message.success(t('delete_success', '删除成功'));
        // 从列表中移除
        setUserTrainedModels(prev => prev.filter(item => item.id !== config.id));
        // 通知其他页面刷新
        window.dispatchEvent(new Event('trainedConfigChanged'));
        // 更新 localStorage 版本号
        const version = Date.now();
        localStorage.setItem('trained_configs_version', version.toString());
      } else {
        message.error(response.message || t('delete_failed', '删除失败'));
      }
    } catch (err) {
      console.error('删除失败:', err);
      message.error(err.response?.data?.message || t('delete_failed', '删除失败'));
    }
  };

  // 在 Dashboard 使用配置（仅保存配置到 localStorage，跳转到 Dashboard，实际调用时才增加使用量）
  const handleUseInDashboard = (config, matchedPreset) => {
    const configData = {
      configId: config.id,
      configName: config.name,
      modelName: config.model_name,
      parameters: config.parsed_params || JSON.parse(config.parameters || '{}'),
      // 保存预设信息，用于 Dashboard 加载
      presetName: matchedPreset?.name || '',
      presetSystemPrompt: matchedPreset?.systemPrompt || '',
      presetId: matchedPreset?.id || '',
    };
    localStorage.setItem('selected_trained_model', JSON.stringify(configData));
    navigate('/dashboard');
  };

  const handleTagClick = (tag) => {
    setSearchText(tag);
    setSelectedTypes([]);
    setSelectedUseCases([]);
    setAllPage(1);
  };

  // 切换模型类型选择
  const toggleType = (type) => {
    if (selectedTypes.includes(type)) {
      setSelectedTypes(selectedTypes.filter(t => t !== type));
    } else {
      setSelectedTypes([...selectedTypes, type]);
    }
    setSearchText('');
    setAllPage(1);
  };

  // 切换应用场景选择
  const toggleUseCase = (uc) => {
    if (selectedUseCases.includes(uc)) {
      setSelectedUseCases(selectedUseCases.filter(u => u !== uc));
    } else {
      setSelectedUseCases([...selectedUseCases, uc]);
    }
    setSearchText('');
    setAllPage(1);
  };

  // 点击全部按钮
  const clearTypes = () => {
    setSelectedTypes([]);
    setSearchText('');
    setAllPage(1);
  };

  const clearUseCases = () => {
    setSelectedUseCases([]);
    setSearchText('');
    setAllPage(1);
  };

  // 排序辅助函数
  const sortModels = (modelList, sortField, sortOrder) => {
    if (sortField === 'default') return modelList;
    
    const sorted = [...modelList].sort((a, b) => {
      let valA, valB;
      
      switch (sortField) {
        case 'model_size':
          // 提取尺寸数值进行排序，如 "70B" -> 70
          valA = parseFloat((a.model_size || '0').replace(/[^\d.]/g, '')) || 0;
          valB = parseFloat((b.model_size || '0').replace(/[^\d.]/g, '')) || 0;
          return sortOrder === 'asc' ? valA - valB : valB - valA;
        case 'price':
          valA = parseFloat(a.price || 0);
          valB = parseFloat(b.price || 0);
          return sortOrder === 'asc' ? valA - valB : valB - valA;
        case 'context_length':
          valA = parseInt(a.context_length || 0, 10);
          valB = parseInt(b.context_length || 0, 10);
          return sortOrder === 'asc' ? valA - valB : valB - valA;
        default:
          return 0;
      }
    });
    
    return sorted;
  };

  // 热门模型排序处理
  const handleHotSortChange = (field) => {
    if (field === hotSortField) {
      // 同一字段，切换升降序
      setHotSortOrder(hotSortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // 不同字段，切换字段并重置为升序
      setHotSortField(field);
      setHotSortOrder('asc');
    }
    setHotPage(1);
  };

  // 全部模型排序处理
  const handleAllSortChange = (field) => {
    if (field === allSortField) {
      // 同一字段，切换升降序
      setAllSortOrder(allSortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // 不同字段，切换字段并重置为升序
      setAllSortField(field);
      setAllSortOrder('asc');
    }
    setAllPage(1);
  };

  // 热门模型标签 - 使用display_name，限制最多20个
  const hotKeywords = hotModels
    .map(m => m.display_name || m.model_name)
    .filter(Boolean)
    .slice(0, 20);

  const getTypeColor = (type) => {
    const colors = {
      chat: '#1890ff',
      embedding: '#52c41a',
      image: '#fa8c16',
      video: '#eb2f96',
      voice: '#722ed1',
    };
    return colors[type] || '#8c8c8c';
  };

  // 支持功能的中英文映射（带emoji）
  const getCapabilityIcon = (cap) => {
    const lang = localStorage.getItem('lang') || 'en';
    const map = {
      'zh': {
        '视觉输入': '👁️ 视觉输入',
        '工具调用': '🛠️ 工具调用',
        '前缀续写': '✍🏻 前缀续写',
        'FIM 补全': '🔤 FIM 补全',
      },
      'en': {
        '视觉输入': '👁️ Vision',
        '工具调用': '🛠️ Tools',
        '前缀续写': '✍🏻 Prefix',
        'FIM 补全': '🔤 FIM',
      }
    };
    return map[lang]?.[cap] || cap;
  };

  // 应用场景标签颜色（使用预计算的颜色映射，确保不重复）
  const getUseCaseColor = (useCase) => {
    return useCaseColorMap[useCase] || { bg: '#f5f5f5', border: '#d9d9d9', text: '#595959' };
  };

  // 获取类型显示名称（根据当前语言）
  const getTypeDisplayName = (type) => {
    const mapping = TYPE_MAPPING[type];
    if (mapping) {
      const lang = localStorage.getItem('lang') || 'en';
      return lang === 'en' ? mapping.en : mapping.cn;
    }
    return type;
  };
  
  // 获取某类型模型数量 - 使用原始全部模型列表进行计数，不受筛选影响
  const getTypeModelCount = (type) => {
    const countSource = allModelsForCount.length > 0 ? allModelsForCount : [...(hotModels || []), ...(models || [])];
    return countSource.filter(m => m.type === type).length;
  };

  // 应用场景标签翻译
  const getUseCaseName = (useCase) => {
    const lang = localStorage.getItem('lang') || 'en';
    if (lang === 'zh') return useCase;
    const names = {
      'All': 'All',
      'AIGC内容创作': 'AIGC Content Creation',
      'Vibe Coding': 'Vibe Coding',
      'Code Generation': 'Code Generation',
      'Code Completion': 'Code Completion',
      'Content Creation': 'Content Creation',
      '内容翻译': 'Content Translation',
      '创意设计': 'Creative Design',
      '图像分析': 'Image Analysis',
      'Image Generation': 'Image Generation',
      '图文问答': 'Image-Text Q&A',
      '复杂推理': 'Complex Reasoning',
      '多模态对话': 'Multimodal Dialogue',
      '多模态理解': 'Multimodal Understanding',
      '客服': 'Customer Service',
      'Chat Assistant': 'Chat Assistant',
      '快速响应': 'Quick Response',
      '快速对话': 'Quick Chat',
      '数学推理': 'Math Reasoning',
      'Math Solving': 'Math Solving',
      '旗舰全能': 'Flagship All-in-One',
      '深度推理': 'Deep Reasoning',
      '游戏互动': 'Gaming Interaction',
      '视觉理解': 'Visual Understanding',
      'Video Generation': 'Video Generation',
      '论文解读': 'Paper Interpretation',
      'Semantic Search': 'Semantic Search',
      '语音交互': 'Voice Interaction',
      'Speech Synthesis': 'Speech Synthesis',
      '通用助手': 'General Assistant',
      'Long Text Processing': 'Long Text Processing',
      '领域知识综合': 'Domain Knowledge Integration',
      '高性价比': 'High Cost Performance',
      '对话助手': 'Chat Assistant',
      '内容创作': 'Content Creation',
      '代码生成': 'Code Generation',
      '长文本处理': 'Long Text Processing',
      '长文本': 'Long Text',
      'RAG': 'RAG',
      '翻译': 'Translation',
      '图像生成': 'Image Generation',
      '文生图': 'Text to Image',
      '视频生成': 'Video Generation',
      '文生视频': 'Text to Video',
      '语音识别': 'Voice Recognition',
      '语音合成': 'Voice Synthesis',
      '智能客服': 'Customer Service',
      '角色扮演': 'Role Play',
      '数据分析': 'Data Analysis',
      '知识问答': 'Q&A',
      '文案撰写': 'Copywriting',
      '摘要生成': 'Summarization',
      '数学解题': 'Math Solving',
      '多模态': 'Multimodal',
      '搜索增强': 'Search Enhancement',
      '文本分类': 'Text Classification',
      '情感分析': 'Sentiment Analysis',
      '信息抽取': 'Info Extraction',
      '问答系统': 'QA System',
      '创意写作': 'Creative Writing',
      '代码补全': 'Code Completion',
      'API开发': 'API Development',
      '数据处理': 'Data Processing',
      '学术研究': 'Academic Research',
      '教育学习': 'Education',
      '办公效率': 'Productivity',
      '编程开发': 'Programming',
      '设计创作': 'Design',
      '娱乐休闲': 'Entertainment',
      '生活助手': 'Life Assistant',
      '商业分析': 'Business Analysis',
      '金融理财': 'Finance',
      '医疗健康': 'Healthcare',
      '法律咨询': 'Legal Advice',
      '新闻资讯': 'News',
      '社交媒体': 'Social Media',
      '电商购物': 'E-commerce',
      '旅游出行': 'Travel',
      '美食烹饪': 'Food & Cooking',
      '运动健身': 'Fitness',
      '音乐创作': 'Music Creation',
      '视频剪辑': 'Video Editing',
      '游戏辅助': 'Gaming',
      '小说创作': 'Novel Writing',
      '诗歌创作': 'Poetry',
      '演讲稿': 'Speech Writing',
      '邮件撰写': 'Email Writing',
      '简历优化': 'Resume Optimization',
      '面试准备': 'Interview Prep',
      '论文写作': 'Academic Writing',
      '报告生成': 'Report Generation',
      'PPT制作': 'Presentation',
      '思维导图': 'Mind Mapping',
      '笔记整理': 'Note Taking',
      '日程管理': 'Schedule Management',
      '任务规划': 'Task Planning',
      '项目管理': 'Project Management',
      '团队协作': 'Team Collaboration',
      '客户服务': 'Customer Support',
      '销售支持': 'Sales Support',
      '市场营销': 'Marketing',
      'SEO优化': 'SEO Optimization',
      '内容审核': 'Content Moderation',
      '数据标注': 'Data Labeling',
      '模型评测': 'Model Evaluation',
      '提示工程': 'Prompt Engineering',
      '知识库': 'Knowledge Base',
      '智能推荐': 'Recommendation',
      '个性化': 'Personalization',
      '预测分析': 'Predictive Analysis',
      '异常检测': 'Anomaly Detection',
      '图像识别': 'Image Recognition',
      '目标检测': 'Object Detection',
      '人脸识别': 'Face Recognition',
      'OCR': 'OCR',
      '文档解析': 'Document Parsing',
      '表格识别': 'Table Recognition',
      '公式识别': 'Formula Recognition',
      '手写识别': 'Handwriting Recognition',
      '场景理解': 'Scene Understanding',
      '图像分割': 'Image Segmentation',
      '风格迁移': 'Style Transfer',
      '图像修复': 'Image Restoration',
      '超分辨率': 'Super Resolution',
      '图像增强': 'Image Enhancement',
      '背景移除': 'Background Removal',
      '智能抠图': 'Smart Cutout',
      '漫画生成': 'Comic Generation',
      '头像生成': 'Avatar Generation',
      'Logo设计': 'Logo Design',
      '海报设计': 'Poster Design',
      'UI设计': 'UI Design',
      '室内设计': 'Interior Design',
      '建筑设计': 'Architecture Design',
      '服装设计': 'Fashion Design',
      '工业设计': 'Industrial Design',
      '3D建模': '3D Modeling',
      '动画制作': 'Animation',
      '特效制作': 'VFX',
      '虚拟主播': 'VTuber',
      '数字人': 'Digital Human',
      '语音克隆': 'Voice Cloning',
      '音色转换': 'Voice Conversion',
      '音乐生成': 'Music Generation',
      '伴奏分离': 'Stem Separation',
      '音效生成': 'Sound Effect',
      '降噪处理': 'Noise Reduction',
      '语音增强': 'Speech Enhancement',
      '实时翻译': 'Real-time Translation',
      '同声传译': 'Simultaneous Interpretation',
      '方言识别': 'Dialect Recognition',
      '多语言': 'Multilingual',
      '跨语言': 'Cross-lingual',
      '代码解释': 'Code Explanation',
      '代码审查': 'Code Review',
      'Bug修复': 'Bug Fix',
      '单元测试': 'Unit Testing',
      '文档生成': 'Documentation',
      '代码重构': 'Code Refactoring',
      '性能优化': 'Performance Optimization',
      '安全审计': 'Security Audit',
      '漏洞检测': 'Vulnerability Detection',
      '智能合约': 'Smart Contract',
      '区块链': 'Blockchain',
      '物联网': 'IoT',
      '边缘计算': 'Edge Computing',
      '自动驾驶': 'Autonomous Driving',
      '机器人': 'Robotics',
      '智能控制': 'Smart Control',
      '工业检测': 'Industrial Inspection',
      '质量检测': 'Quality Inspection',
      '缺陷检测': 'Defect Detection',
      '预测维护': 'Predictive Maintenance',
      '供应链': 'Supply Chain',
      '库存管理': 'Inventory Management',
      '需求预测': 'Demand Forecasting',
      '价格优化': 'Price Optimization',
      '风险管理': 'Risk Management',
      '欺诈检测': 'Fraud Detection',
      '信用评估': 'Credit Scoring',
      '智能投顾': 'Robo-advisory',
      '保险理赔': 'Insurance Claims',
      '医疗影像': 'Medical Imaging',
      '药物研发': 'Drug Discovery',
      '基因分析': 'Genomic Analysis',
      '蛋白质结构': 'Protein Structure',
      '分子生成': 'Molecule Generation',
      '临床试验': 'Clinical Trials',
      '电子病历': 'EHR',
      '智能问诊': 'Smart Diagnosis',
      '健康管理': 'Health Management',
      '心理咨询': 'Psychological Counseling',
      '法律文档': 'Legal Document',
      '合同审核': 'Contract Review',
      '案件分析': 'Case Analysis',
      '合规检查': 'Compliance Check',
      '知识产权': 'Intellectual Property',
      '专利分析': 'Patent Analysis',
      '商标注册': 'Trademark Registration',
      '版权保护': 'Copyright Protection',
      '舆情监控': 'Public Opinion Monitoring',
      '危机公关': 'Crisis PR',
      '品牌管理': 'Brand Management',
      '用户画像': 'User Profiling',
      '行为分析': 'Behavior Analysis',
      '留存分析': 'Retention Analysis',
      '转化优化': 'Conversion Optimization',
      'A/B测试': 'A/B Testing',
      '问卷设计': 'Survey Design',
      '数据分析报告': 'Data Report',
      '可视化': 'Visualization',
      '大屏展示': 'Dashboard',
      '报表生成': 'Report Generation',
      '数据挖掘': 'Data Mining',
      '机器学习': 'Machine Learning',
      '深度学习': 'Deep Learning',
      '强化学习': 'Reinforcement Learning',
      '迁移学习': 'Transfer Learning',
      '联邦学习': 'Federated Learning',
      'AutoML': 'AutoML',
      'MLOps': 'MLOps',
      '模型训练': 'Model Training',
      '模型部署': 'Model Deployment',
      '模型监控': 'Model Monitoring',
      '特征工程': 'Feature Engineering',
      '超参调优': 'Hyperparameter Tuning',
      '神经网络': 'Neural Networks',
      '计算机视觉': 'Computer Vision',
      '自然语言处理': 'NLP',
      '语音识别': 'Speech Recognition',
      '语音合成': 'Speech Synthesis',
      '机器翻译': 'Machine Translation',
      '文本生成': 'Text Generation',
      '问答系统': 'Question Answering',
      '对话系统': 'Dialogue System',
      '情感计算': 'Affective Computing',
      '知识图谱': 'Knowledge Graph',
      '语义搜索': 'Semantic Search',
      '智能写作': 'Intelligent Writing',
      '智能编辑': 'Intelligent Editing',
      '智能校对': 'Proofreading',
      '智能排版': 'Typesetting',
      '智能翻译': 'Smart Translation',
      '智能摘要': 'Smart Summarization',
      '智能分类': 'Smart Classification',
      '智能标签': 'Smart Tagging',
      '智能推荐': 'Smart Recommendation',
      '智能匹配': 'Smart Matching',
      '智能排序': 'Smart Ranking',
      '智能筛选': 'Smart Filtering',
      '智能搜索': 'Smart Search',
      '智能问答': 'Smart Q&A',
      '智能对话': 'Smart Dialogue',
      '智能客服': 'Smart Customer Service',
      '智能助手': 'Smart Assistant',
      '智能代理': 'Smart Agent',
      '智能决策': 'Smart Decision',
      '智能预测': 'Smart Prediction',
      '智能优化': 'Smart Optimization',
      '智能调度': 'Smart Scheduling',
      '智能规划': 'Smart Planning',
      '智能控制': 'Smart Control',
      '智能监控': 'Smart Monitoring',
      '智能告警': 'Smart Alert',
      '智能运维': 'Smart Ops',
      '智能测试': 'Smart Testing',
      '智能调试': 'Smart Debugging',
      '智能诊断': 'Smart Diagnosis',
      '智能修复': 'Smart Repair',
      '智能升级': 'Smart Upgrade',
      '智能备份': 'Smart Backup',
      '智能恢复': 'Smart Recovery',
      '智能迁移': 'Smart Migration',
      '智能同步': 'Smart Sync',
      '智能分发': 'Smart Distribution',
      '智能缓存': 'Smart Cache',
      '智能压缩': 'Smart Compression',
      '智能加密': 'Smart Encryption',
      '智能解密': 'Smart Decryption',
      '智能签名': 'Smart Signature',
      '智能验证': 'Smart Verification',
      '智能认证': 'Smart Authentication',
      '智能授权': 'Smart Authorization',
      '智能审计': 'Smart Audit',
      '智能日志': 'Smart Logging',
      '智能追踪': 'Smart Tracing',
      '智能监控': 'Smart Monitoring',
      '智能分析': 'Smart Analysis',
      '智能报表': 'Smart Reporting',
      '智能告警': 'Smart Alerting',
      '智能通知': 'Smart Notification',
      '智能提醒': 'Smart Reminder',
      '智能推送': 'Smart Push',
      '智能订阅': 'Smart Subscribe',
      '智能发布': 'Smart Publish',
      '智能订阅': 'Smart Subscription',
      '智能分发': 'Smart Distribution',
      '智能路由': 'Smart Routing',
      '智能负载': 'Smart Load Balancing',
      '智能限流': 'Smart Rate Limiting',
      '智能熔断': 'Smart Circuit Breaker',
      '智能降级': 'Smart Degradation',
      '智能重试': 'Smart Retry',
      '智能超时': 'Smart Timeout',
      '智能重连': 'Smart Reconnection',
      '智能心跳': 'Smart Heartbeat',
      '智能探测': 'Smart Probe',
      '智能健康': 'Smart Health',
      '智能度量': 'Smart Metrics',
      '智能追踪': 'Smart Tracing',
      '智能画像': 'Smart Profiling',
      '智能治理': 'Smart Governance',
      '智能编排': 'Smart Orchestration',
      '智能调度': 'Smart Scheduling',
      '智能编排': 'Smart Choreography',
      '智能工作流': 'Smart Workflow',
      '智能流水线': 'Smart Pipeline',
      '智能构建': 'Smart Build',
      '智能集成': 'Smart Integration',
      '智能交付': 'Smart Delivery',
      '智能部署': 'Smart Deployment',
      '智能发布': 'Smart Release',
      '智能回滚': 'Smart Rollback',
      '智能灰度': 'Smart Canary',
      '智能蓝绿': 'Smart Blue-Green',
      '智能金丝雀': 'Smart Canary',
      '智能A/B测试': 'Smart A/B Testing',
      '智能分流': 'Smart Traffic Split',
      '智能染色': 'Smart Traffic Dyeing',
      '智能影子': 'Smart Shadow',
      '智能压测': 'Smart Load Testing',
      '智能混沌': 'Smart Chaos',
      '智能容灾': 'Smart Disaster Recovery',
      '智能备份': 'Smart Backup',
      '智能恢复': 'Smart Recovery',
      '智能迁移': 'Smart Migration',
      '智能扩缩容': 'Smart Scaling',
      '智能弹性': 'Smart Elasticity',
      '智能资源': 'Smart Resource',
      '智能成本': 'Smart Cost',
      '智能计费': 'Smart Billing',
      '智能配额': 'Smart Quota',
      '智能限速': 'Smart Throttling',
      '智能优先级': 'Smart Priority',
      '智能队列': 'Smart Queue',
      '智能缓冲': 'Smart Buffer',
      '智能池化': 'Smart Pooling',
      '智能连接': 'Smart Connection',
      '智能会话': 'Smart Session',
      '智能状态': 'Smart State',
      '智能缓存': 'Smart Cache',
      '智能存储': 'Smart Storage',
      '智能计算': 'Smart Computing',
      '智能网络': 'Smart Network',
      '智能安全': 'Smart Security',
      '智能隐私': 'Smart Privacy',
      '智能合规': 'Smart Compliance',
      '智能风控': 'Smart Risk Control',
      '智能反欺诈': 'Smart Anti-Fraud',
      '智能反垃圾': 'Smart Anti-Spam',
      '智能反作弊': 'Smart Anti-Cheat',
      '智能内容安全': 'Smart Content Safety',
      '智能舆情': 'Smart Public Opinion',
      '智能情报': 'Smart Intelligence',
      '智能态势': 'Smart Situation',
      '智能预警': 'Smart Early Warning',
      '智能应急': 'Smart Emergency',
      '智能指挥': 'Smart Command',
      '智能调度': 'Smart Dispatch',
      '智能协同': 'Smart Collaboration',
      '智能联动': 'Smart Linkage',
      '智能融合': 'Smart Fusion',
      '智能集成': 'Smart Integration',
      '智能互联': 'Smart Interconnection',
      '智能物联': 'Smart IoT',
      '智能边缘': 'Smart Edge',
      '智能端侧': 'Smart Endpoint',
      '智能云端': 'Smart Cloud',
      '智能混合': 'Smart Hybrid',
      '智能多云': 'Smart Multi-Cloud',
      '智能分布式': 'Smart Distributed',
      '智能集群': 'Smart Cluster',
      '智能网格': 'Smart Mesh',
      '智能服务': 'Smart Service',
      '智能微服务': 'Smart Microservices',
      '智能服务网格': 'Smart Service Mesh',
      '智能中台': 'Smart Middle Platform',
      '智能平台': 'Smart Platform',
      '智能生态': 'Smart Ecosystem',
      '智能开放': 'Smart Open',
      '智能合作': 'Smart Partnership',
      '智能共创': 'Smart Co-creation',
      '智能共享': 'Smart Sharing',
      '智能共赢': 'Smart Win-Win',
      '智能可持续': 'Smart Sustainable',
      '智能绿色': 'Smart Green',
      '智能环保': 'Smart Environmental',
      '智能节能': 'Smart Energy Saving',
      '智能低碳': 'Smart Low Carbon',
      '智能循环': 'Smart Circular',
      '智能再生': 'Smart Regenerative',
      '智能未来': 'Smart Future',
      '通用': 'General',
      '通用模型': 'General Model',
      '基础模型': 'Foundation Model',
      '大模型': 'Large Model',
      '小模型': 'Small Model',
      '轻量级': 'Lightweight',
      '高性能': 'High Performance',
      '高效率': 'High Efficiency',
      '低成本': 'Low Cost',
      '开源': 'Open Source',
      '商业': 'Commercial',
      '免费': 'Free',
      '试用': 'Trial',
      '企业': 'Enterprise',
      '个人': 'Personal',
      '教育': 'Education',
      '研究': 'Research',
      '开发': 'Development',
      '生产': 'Production',
      '测试': 'Testing',
      '演示': 'Demo',
      '实验': 'Experimental',
      '预览': 'Preview',
      'Beta': 'Beta',
      'Alpha': 'Alpha',
      '稳定': 'Stable',
      '最新': 'Latest',
      '热门': 'Popular',
      '推荐': 'Recommended',
      '精选': 'Featured',
      '新品': 'New',
      '经典': 'Classic',
      '专业': 'Professional',
      '入门': 'Beginner',
      '进阶': 'Intermediate',
      '高级': 'Advanced',
      '专家': 'Expert',
      '全能': 'All-in-One',
      '专用': 'Specialized',
      '特定': 'Specific',
      '特定领域': 'Domain Specific',
      '垂直': 'Vertical',
      '水平': 'Horizontal',
      '跨领域': 'Cross-domain',
      '多任务': 'Multi-task',
      '单任务': 'Single-task',
      '端到端': 'End-to-End',
      '模块化': 'Modular',
      '可扩展': 'Scalable',
      '可定制': 'Customizable',
      '可配置': 'Configurable',
      '可插拔': 'Pluggable',
      '可升级': 'Upgradable',
      '可维护': 'Maintainable',
      '可靠': 'Reliable',
      '可用': 'Available',
      '可信': 'Trustworthy',
      '可解释': 'Explainable',
      '透明': 'Transparent',
      '公平': 'Fair',
      '无偏见': 'Unbiased',
      '安全': 'Secure',
      '隐私保护': 'Privacy-Preserving',
      '联邦': 'Federated',
      '分布式': 'Distributed',
      '去中心化': 'Decentralized',
      '区块链': 'Blockchain',
      '可信执行': 'Trusted Execution',
      '硬件加速': 'Hardware Accelerated',
      'GPU加速': 'GPU Accelerated',
      'CPU优化': 'CPU Optimized',
      '移动端': 'Mobile',
      '嵌入式': 'Embedded',
      '边缘端': 'Edge',
      '云端': 'Cloud',
      '本地': 'On-premise',
      '私有化': 'Private',
      '混合云': 'Hybrid Cloud',
      '多云': 'Multi-Cloud',
      '跨云': 'Cross-Cloud',
      'Serverless': 'Serverless',
      '容器化': 'Containerized',
      'Kubernetes': 'Kubernetes',
      'Docker': 'Docker',
      'VM': 'VM',
      '裸金属': 'Bare Metal',
      '虚拟化': 'Virtualized',
      '高性能计算': 'HPC',
      '量子计算': 'Quantum',
      '神经形态': 'Neuromorphic',
      '光子计算': 'Photonic',
      '生物计算': 'Biological',
      'DNA计算': 'DNA Computing',
      '类脑': 'Brain-inspired',
      '认知': 'Cognitive',
      '感知': 'Perceptual',
      '推理': 'Reasoning',
      '规划': 'Planning',
      '决策': 'Decision',
      '学习': 'Learning',
      '记忆': 'Memory',
      '注意力': 'Attention',
      'Transformer': 'Transformer',
      'BERT': 'BERT',
      'GPT': 'GPT',
      'LLaMA': 'LLaMA',
      'Claude': 'Claude',
      'Gemini': 'Gemini',
      'PaLM': 'PaLM',
      '文心': 'ERNIE',
      '通义': 'Tongyi',
      '盘古': 'Pangu',
      '混元': 'Hunyuan',
      '星火': 'Spark',
      '商量': 'SenseChat',
      '日日新': 'SenseNova',
      '天工': 'Tiangong',
      '智谱': 'Zhipu',
      '百川': 'Baichuan',
      '零一万物': '01.AI',
      '月之暗面': 'Moonshot',
      'MiniMax': 'MiniMax',
      '深度求索': 'DeepSeek',
      '面壁智能': 'ModelBest',
      '阶跃星辰': 'Stepfun',
      '澜舟科技': 'Langboat',
      '光年之外': 'LightYear',
      '元象': 'XVERSE',
      ' IDEA': ' IDEA',
      '西湖心辰': 'Westlake',
      '聆心智能': 'Spirit',
      '思必驰': 'AISpeech',
      '云知声': 'Unisound',
      '出门问问': 'Mobvoi',
      'ROKID': 'ROKID',
      '小i机器人': 'Xiaoi',
      '图灵': 'Turing',
      '竹间智能': 'Emotibot',
      '追一科技': 'Zhuiyi',
      '容联云': 'Yuntongxun',
      '科大讯飞': 'iFlytek',
      '百度': 'Baidu',
      '阿里': 'Alibaba',
      '腾讯': 'Tencent',
      '华为': 'Huawei',
      '字节': 'ByteDance',
      '京东': 'JD',
      '美团': 'Meituan',
      '小米': 'Xiaomi',
      'OPPO': 'OPPO',
      'vivo': 'vivo',
      '荣耀': 'Honor',
      '一加': 'OnePlus',
      '魅族': 'Meizu',
      '努比亚': 'Nubia',
      '红魔': 'RedMagic',
      'ROG': 'ROG',
      '黑鲨': 'Black Shark',
      '联想': 'Lenovo',
      '戴尔': 'Dell',
      '惠普': 'HP',
      '华硕': 'ASUS',
      '宏碁': 'Acer',
      '微星': 'MSI',
      '技嘉': 'Gigabyte',
      '华擎': 'ASRock',
      '映泰': 'Biostar',
      '七彩虹': 'Colorful',
      '影驰': 'Galax',
      '索泰': 'ZOTAC',
      '耕升': 'Gainward',
      '铭瑄': 'Maxsun',
      '盈通': 'Yeston',
      '昂达': 'Onda',
      '梅捷': 'SOYO',
      '翔升': 'ASL',
      '双敏': 'UNIKA',
      '镭风': 'Colorfire',
      '迪兰': 'Dataland',
      '蓝宝石': 'Sapphire',
      '撼讯': 'PowerColor',
      '讯景': 'XFX',
      '华擎': 'ASRock',
      '映众': 'Inno3D',
      '丽台': 'Leadtek',
      '旌宇': 'Sparkle',
      '艾尔莎': 'ELSA',
      'PNY': 'PNY',
      'EVGA': 'EVGA',
      '同德': 'Palit',
      '耕宇': 'Gainward',
    };
    return names[useCase] || useCase;
  };

  // 模型类型标签颜色 - 8种类型各有不同颜色
  const getTypeTagStyle = (type) => {
    const colorMap = {
      text: { bg: '#e6f4ff', border: '#91caff', text: '#0958d9' },           // 蓝色 - 对话
      image: { bg: '#fff7e6', border: '#ffd591', text: '#d46b08' },           // 橙色 - 图像
      embeddings: { bg: '#f6ffed', border: '#b7eb8f', text: '#389e0d' },       // 绿色 - 嵌入
      audio: { bg: '#fff0f6', border: '#ffadd2', text: '#eb2f96' },            // 粉色 - 语音
      video: { bg: '#fff1f0', border: '#ffccc7', text: '#cf1322' },            // 红色 - 视频
      rerank: { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },           // 紫色 - 重排序
      speech: { bg: '#e6fffb', border: '#87e8de', text: '#08979c' },          // 青色 - 语音合成
      transcription: { bg: '#fffbe6', border: '#ffe58f', text: '#d48806' },   // 黄色 - 语音识别
    };
    return colorMap[type] || { bg: '#f5f5f5', border: '#d9d9d9', text: '#595959' };
  };

  // 获取模型类型的显示名称（根据当前语言）
  const getTypeName = (type) => {
    const mapping = TYPE_MAPPING[type];
    if (mapping) {
      const lang = localStorage.getItem('lang') || 'en';
      return lang === 'en' ? mapping.en : mapping.cn;
    }
    return type;
  };

  // 渲染模型卡片
  const renderModelCard = (model) => {
    // 获取当前卡片的所有标签
    const cardTags = model.use_case ? model.use_case.split(',').slice(0, 3).map(t => t.trim()) : [];
    
    // 为当前卡片内的标签分配不重复的颜色
    const cardColorMap = {};
    const usedColors = new Set();
    
    // 先分配预定义颜色，但避免同卡片内重复
    const allColors = [
      { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
      { bg: '#e6f4ff', border: '#91caff', text: '#1890ff' },
      { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
      { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
      { bg: '#fff1f0', border: '#ffccc7', text: '#ff4d4f' },
      { bg: '#fff0f6', border: '#ffadd2', text: '#eb2f96' },
      { bg: '#e6fffb', border: '#87e8de', text: '#13c2c2' },
      { bg: '#e6f7ff', border: '#91caff', text: '#0958d9' },
    ];
    
    cardTags.forEach(tag => {
      // 优先使用全局映射中的颜色（如果有的话）
      if (useCaseColorMap[tag] && !usedColors.has(useCaseColorMap[tag].bg)) {
        cardColorMap[tag] = useCaseColorMap[tag];
        usedColors.add(useCaseColorMap[tag].bg);
      } else {
        // 找一个未使用的颜色
        let found = false;
        for (let i = 0; i < allColors.length; i++) {
          if (!usedColors.has(allColors[i].bg)) {
            cardColorMap[tag] = allColors[i];
            usedColors.add(allColors[i].bg);
            found = true;
            break;
          }
        }
        // 如果都用过了，随机分配一个
        if (!found) {
          const idx = Math.abs(tag.split('').reduce((h, c) => (h << 5) - h + c.charCodeAt(0), 0)) % allColors.length;
          cardColorMap[tag] = allColors[idx];
        }
      }
    });
    
    return (
    <div className="model-card-wrapper">
      <div className="model-card-inner">
        {/* 正面内容 */}
        <div className="model-front">
          {/* 第一行: Logo + 品牌 + 类型 */}
          <div className="model-header">
            <div className="model-logo">
              {getModelLogo(model)}
            </div>
            <div className="model-brand">
              <span className="brand-label">{model.provider?.display_name || 'AI'}</span>
            </div>
            <div className="model-type-right">
              <Tag style={{ 
                fontSize: '11px',
                padding: '2px 10px',
                lineHeight: '20px',
                margin: 0,
                background: getTypeTagStyle(model.type).bg,
                borderColor: getTypeTagStyle(model.type).border,
                color: getTypeTagStyle(model.type).text,
                borderRadius: '4px'
              }}>
                {getTypeName(model.type)}
              </Tag>
            </div>
          </div>
          
          {/* 第二行: 品牌/版本号 */}
          <div className="model-version">
            <span className="version-name">{(model.provider?.display_name || 'AI') + '/' + (model.display_name || model.model_name)}</span>
          </div>
          
          {/* 第三行: 发布时间 */}
          <div className="model-release">
            <span className="release-date">{t('release_date')}: {model.release_date || '2026-01-05'}</span>
          </div>
          
          {/* 第四行: 应用场景标签 */}
          <div className="model-tags">
            {cardTags.map((tag, i) => {
              const color = cardColorMap[tag] || { bg: '#f5f5f5', border: '#d9d9d9', text: '#595959' };
              return (
                <Tag 
                  key={i} 
                  style={{ 
                    background: color.bg, 
                    borderColor: color.border, 
                    color: color.text,
                    fontSize: '11px',
                    padding: '2px 10px',
                    lineHeight: '18px',
                    margin: 0,
                    borderRadius: '4px'
                  }}
                >
                  {getUseCaseName(tag)}
                </Tag>
              );
            })}
          </div>
          
          {/* 第五行: 价格 - 根据计费方式显示不同内容 */}
          <div className="model-prices">
            {model.billing_type === 'per_token' && (
              <>
                <div className="price-item">
                  <span className="price-label">{t('input')}</span>
                  <span className="price-value">$ {parseFloat(model.input_price || 0).toFixed(4)} / K Tokens</span>
                </div>
                <div className="price-divider-line"></div>
                <div className="price-item">
                  <span className="price-label">{t('output')}</span>
                  <span className="price-value">$ {parseFloat(model.output_price || 0).toFixed(4)} / K Tokens</span>
                </div>
              </>
            )}
            {model.billing_type === 'per_call' && (
              <div className="price-item price-single">
                <span className="price-label">{t('per_call', 'Per Call')}</span>
                <span className="price-value">$ {parseFloat(model.billing_rate || 0).toFixed(4)} / {t('call', 'Call')}</span>
              </div>
            )}
            {model.billing_type === 'per_char' && (
              <div className="price-item price-single">
                <span className="price-label">{t('per_char', 'Per K Chars')}</span>
                <span className="price-value">$ {parseFloat(model.input_price || 0).toFixed(6)} / {t('k_chars', 'K Chars')}</span>
              </div>
            )}
            {model.billing_type === 'per_second' && (
              <div className="price-item price-single">
                <span className="price-label">{t('per_second', 'Per Second')}</span>
                <span className="price-value">$ {parseFloat(model.input_price || 0).toFixed(6)} / {t('second', 's')}</span>
              </div>
            )}
            {model.billing_type === 'free' && (
              <div className="price-item price-free">
                <span className="price-label">{t('billing', 'Billing')}</span>
                <span className="price-value">{t('free', 'FREE')}</span>
              </div>
            )}
            {!model.billing_type && (
              <>
                <div className="price-item">
                  <span className="price-label">{t('input')}</span>
                  <span className="price-value">$ {parseFloat(model.input_price || 0).toFixed(4)} / K Tokens</span>
                </div>
                <div className="price-divider-line"></div>
                <div className="price-item">
                  <span className="price-label">{t('output')}</span>
                  <span className="price-value">$ {parseFloat(model.output_price || 0).toFixed(4)} / K Tokens</span>
                </div>
              </>
            )}
          </div>
        </div>
        
        {/* 背面内容 (hover显示) */}
        <div className="model-back">
          {/* 第一行: Logo + 版本 + 类型 */}
          <div className="back-header">
            <div className="model-logo">
              {getModelLogo(model)}
            </div>
            <div className="model-brand">
              <span className="brand-label">{model.display_name || model.model_name}</span>
            </div>
            <div className="model-type-right">
              <Tag style={{ 
                fontSize: '11px',
                padding: '2px 10px',
                lineHeight: '20px',
                margin: 0,
                background: getTypeTagStyle(model.type).bg,
                borderColor: getTypeTagStyle(model.type).border,
                color: getTypeTagStyle(model.type).text,
                borderRadius: '4px'
              }}>
                {getTypeName(model.type)}
              </Tag>
            </div>
          </div>
          
          <div className="back-middle">
            <div className="back-section">
              <p className="back-desc">{model.description || t('no_description')}</p>
            </div>
            
            <div className="back-section">
              <div className="section-label">{t('capabilities')}</div>
              <div className="back-caps">
                {model.capabilities ? model.capabilities.split(',').slice(0, 4).map((cap, i) => (
                  <Tag key={i} className="cap-tag">{getCapabilityIcon(cap.trim())}</Tag>
                )) : null}
              </div>
            </div>
          </div>
          
          <div className="back-specs">
            <div className="spec-item spec-item-left">
              <span className="spec-label">{t('context')}</span>
              <span className="spec-value">{model.context_length || '-'}</span>
            </div>
            <div className="spec-item spec-item-right">
              <span className="spec-label">{t('size')}</span>
              <span className="spec-value">{model.model_size || '-'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  return (
    <div className="model-square-container">
      {/* 搜索框区域 - 全宽背景图，包含页面标题和筛选条件 */}
      <div className="bg-wrapper">
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '30px 130px 0' }}>
          {/* 大标题区域 - 移到搜索框上方，居中显示 */}
          <div style={{ marginBottom: 20, textAlign: 'center' ,marginTop: 100}}>
            <h1 className="typing-title" style={{ margin: 0, fontSize: 45, fontWeight: 600, background: 'linear-gradient(90deg, #C647FC 19.71%, #437EFF 50.34%, #6E29F6 80.6%)', backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              {typedText}<span className="typing-cursor">|</span>
            </h1>
            <p className={`typing-subtitle ${subtitleVisible ? 'subtitle-visible' : ''}`} style={{ margin: '12px 0 0', fontSize: 20, fontWeight: 600, color: '#4b4949', textShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              {t('model_square_subtitle')}
            </p>
          </div>

          {/* 搜索框区域 */}
          <div style={{ textAlign: 'center', marginBottom: 20, paddingTop: 30 }}>
            <Input.Search
              placeholder={t('search_placeholder')}
              prefix={<SearchOutlined style={{ color: '#999' }} />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onSearch={handleSearch}
              allowClear
              enterButton={<span style={{ padding: '0 16px' }}>{t('search')}</span>}
              size="middle"
              style={{ maxWidth: 600 }}
            />
            
            {hotKeywords.length > 0 && (
              <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 14 }}>
                <span style={{ color: '#333', fontSize: 13, fontWeight: 600, flexShrink: 0, marginRight: 8 }}>
                  <FireOutlined style={{ color: '#ff6b6b', marginRight: 4 }} />
                  {t('hot_models_title')}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                  {hotKeywords.map((keyword, index) => (
                    <Tag key={index} onClick={() => handleTagClick(keyword)} className="keyword-tag-bg">{keyword}</Tag>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 模型类型和应用场景筛选 - 放在背景图内部，渐变遮罩下方 */}
        <div style={{ position: 'relative', zIndex: 1, padding: '24px 130px 24px', marginTop: 30 }}>
          {/* 模型类型筛选 */}
          {types.length > 0 && (
            <div style={{ marginBottom: 22, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 14 }}>
              <div style={{ color: '#333', fontSize: 14, fontWeight: 600, flexShrink: 0, marginRight: 8 }}>{t('model_type')}</div>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <Tag 
                  onClick={clearTypes}
                  className={selectedTypes.length === 0 ? 'type-tag-active' : 'type-tag-bg'}
                >
                  {t('all')}
                </Tag>
                {types.map(type => (
                  <Tag key={type} onClick={() => toggleType(type)} className={selectedTypes.includes(type) ? 'type-tag-active' : 'type-tag-bg'}>
                    {getTypeDisplayName(type)} ({getTypeModelCount(type)})
                  </Tag>
                ))}
              </div>
            </div>
          )}

          {/* 应用场景筛选 */}
          {useCases.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <span style={{ color: '#333', fontSize: 14, fontWeight: 600, flexShrink: 0, marginRight: 8 }}>{t('use_case')}</span>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <Tag 
                  onClick={clearUseCases}
                  className={selectedUseCases.length === 0 ? 'type-tag-active' : 'type-tag-bg'}
                >
                  {t('all')}
                </Tag>
                {useCases.map(uc => (
                  <Tag 
                    key={uc} 
                    onClick={() => toggleUseCase(uc)} 
                    className={selectedUseCases.includes(uc) ? 'type-tag-active' : 'type-tag-bg'}
                  >
                    {getUseCaseName(uc)}
                  </Tag>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 我的训练模型 - 仅在 my-training tab 显示 */}
      {activeTab === 'my-training' && (
        <div style={{ marginBottom: 40, padding: '0 40px' }}>
          <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 32, lineHeight: '32px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <ExperimentOutlined style={{ color: '#722ed1', fontSize: 16 }} />
              <span style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>{t('my_training', '我的训练')}</span>
              <span style={{ color: '#999', fontSize: 14 }}>({trainedTotal})</span>
            </div>
            <Link to="/dashboard/model-training">
              <Button type="primary" size="small" icon={<ThunderboltOutlined />}>
                {t('go_train', '去训练')}
              </Button>
            </Link>
          </div>

          {userTrainedModels.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span>
                  {t('no_trained_models', '您还没有训练模型。')}
                  <Link to="/dashboard/model-training"> {t('go_train_now', '去训练')} →</Link>
                </span>
              }
            />
          ) : (
            <>
              <Row gutter={[16, 16]}>
                {userTrainedModels.map(config => {
                  const params = config.parsed_params || JSON.parse(config.parameters || '{}');
                  // 使用彩虹颜色
                  const rainbowColors = [
                    { bg: '#e6f7ff', icon: '#1890ff' },
                    { bg: '#f6ffed', icon: '#52c41a' },
                    { bg: '#f9f0ff', icon: '#722ed1' },
                    { bg: '#fff7e6', icon: '#fa8c16' },
                    { bg: '#fff0f6', icon: '#eb2f96' },
                    { bg: '#e6fffb', icon: '#13c2c2' },
                    { bg: '#f0f5ff', icon: '#597ef7' },
                  ];
                  const colorIndex = config.id ? Math.abs(config.id.toString().split('').reduce((a, c) => a + c.charCodeAt(0), 0)) % rainbowColors.length : 0;
                  const colors = rainbowColors[colorIndex];
                  
                  // 匹配预设：查找 system_prompt 匹配的预设
                  const matchedPreset = params.system_prompt 
                    ? presets.find(p => p.systemPrompt === params.system_prompt)
                    : null;

                  return (
                    <Col xs={24} sm={12} md={8} lg={6} xl={6} key={config.id}>
                      <Card
                        hoverable
                        className="model-card"
                        style={{
                          borderRadius: 12,
                          overflow: 'hidden',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                          transition: 'all 0.3s ease',
                        }}
                        styles={{ body: { padding: 0 } }}
                          cover={
                          <div style={{
                            height: 80,
                            background: `linear-gradient(135deg, ${colors.icon}15, ${colors.icon}05)`,
                            borderBottom: `3px solid ${colors.icon}30`,
                            padding: '10px 16px',
                            display: 'flex',
                            alignItems: 'stretch',
                            justifyContent: 'space-between',
                          }}>
                            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 10, height: 36 }}>
                                <div style={{
                                  width: 36, height: 36, borderRadius: 8,
                                  background: colors.bg,
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  flexShrink: 0,
                                }}>
                                  <ExperimentOutlined style={{ color: colors.icon, fontSize: 16 }} />
                                </div>
                                <div style={{ fontWeight: 600, fontSize: 15, color: '#262626', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
                                  {config.name}
                                </div>
                              </div>
                              {/* 第二行：预设行 */}
                              <div style={{ height: 20, display: 'flex', alignItems: 'flex-start', minWidth: 0, marginBottom: 10 }}>
                                {matchedPreset && (
                                  <>
                                    <Tag color="green" style={{ marginBottom: 0, fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(50% - 2px)', flexShrink: 0 }} title={`${t('preset_label', 'Preset')}: ${matchedPreset.name}`}>
                                      {t('preset_label', 'Preset')}: {matchedPreset.name}
                                    </Tag>
                                    {matchedPreset.model && (
                                      <Tag color="purple" style={{ marginBottom: 0, fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(50% - 2px)', flexShrink: 0 }} title={`${t('preset_model', 'Preset Model')}: ${matchedPreset.model}`}>
                                        {t('preset_model', 'Preset Model')}: {matchedPreset.model}
                                      </Tag>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        {/* 内容区域 */}
                        <div style={{ padding: '12px 16px' }}>
                          {/* System prompt 预览 - 2行 */}
                          <p
                            style={{
                              height: 36,
                              color: '#595959',
                              fontSize: 12,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              margin: 0,
                            }}
                          >
                            {params.system_prompt || t('no_system_prompt', '无系统提示词')}
                          </p>

                          {/* 全部参数标签 - 2行 */}
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, height: 50, overflow: 'hidden', marginTop: 10, marginBottom: 10}}>
                            {Object.entries(params).filter(([key, value]) => !(value === undefined || value === null || value === '' || key === 'system_prompt')).slice(0, 6).map(([key, value]) => {
                              const displayKey = key.length > 8 ? key.substring(0, 6) + '..' : key;
                              return (
                                <Tag key={key} style={{ fontSize: 10, padding: '0 6px', margin: 0, flexShrink: 0 }} title={`${key}: ${value}`}>
                                  {displayKey}: {typeof value === 'number' ? (Number.isInteger(value) ? value : value.toFixed(2)) : String(value).substring(0, 8)}
                                </Tag>
                              );
                            })}
                          </div>

                          {/* 底部操作 - 固定高度 */}
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, height: 28 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 1, minWidth: 0 }}>
                              <span style={{ fontSize: 11, color: 'rgba(0, 0, 0, 0.45)', flexShrink: 0, whiteSpace: 'nowrap' }}>
                                {t('used_count', 'Used')}: {config.use_count || 0}
                              </span>
                              <span style={{ fontSize: 11, color: '#13c2c2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }} title={config.model_name}>
                                {config.model_name}
                              </span>
                            </div>
                            <Space size={4}>
                              <Tooltip title={t('use_now', '立即使用')}>
                                <Button
                                  type="primary"
                                  size="small"
                                  icon={<MessageOutlined />}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUseInDashboard(config, matchedPreset);
                                  }}
                                  style={{ borderRadius: 6 }}
                                />
                              </Tooltip>
                              <Tooltip title={t('continue_training', '继续训练')}>
                                <Button
                                  size="small"
                                  icon={<ExperimentOutlined />}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleContinueTraining(config, matchedPreset);
                                  }}
                                  style={{ borderRadius: 6 }}
                                />
                              </Tooltip>
                              <Popconfirm
                                title={t('confirm_delete', '确认删除？')}
                                description={t('delete_tip', '删除后无法恢复')}
                                onConfirm={(e) => {
                                  e?.stopPropagation();
                                  handleDeleteConfig(config);
                                }}
                                onCancel={(e) => e?.stopPropagation()}
                                okText={t('confirm', '确认')}
                                cancelText={t('cancel', '取消')}
                              >
                                <Button
                                  type="text"
                                  size="small"
                                  danger
                                  icon={<DeleteOutlined />}
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ padding: '4px 8px', height: 'auto' }}
                                />
                              </Popconfirm>
                            </Space>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
              {/* 分页 */}
              {trainedTotal > trainedPageSize && (
                <div style={{ marginTop: 24, textAlign: 'center' }}>
                  <Pagination
                    current={trainedPage}
                    pageSize={trainedPageSize}
                    total={trainedTotal}
                    onChange={(page, pageSize) => {
                      setTrainedPage(page);
                      setTrainedPageSize(pageSize);
                    }}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total) => `${t('total', '共')} ${total} ${t('items', '条')}`}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* 热门模型 - 仅在 all tab 显示 */}
      {activeTab === 'all' && hotModels.length > 0 && !searchText && selectedTypes.length === 0 && selectedUseCases.length === 0 && (
        <div style={{ marginBottom: 40, padding: '0 40px' }}>
          <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <ThunderboltOutlined style={{ color: '#722ed1' }} />
              <span style={{ fontSize: 16, fontWeight: 500 }}>{t('hot_models_title')}</span>
              <span style={{ color: '#999', fontSize: 14 }}>({hotModels.length}{t('models_count')})</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Select
                value={hotSortField}
                onChange={handleHotSortChange}
                style={{ width: 120 }}
                size="small"
              >
                <Select.Option value="default">{t('default_sort')}</Select.Option>
                <Select.Option value="model_size">{t('sort_by_size')}</Select.Option>
                <Select.Option value="price">{t('sort_by_price')}</Select.Option>
                <Select.Option value="context_length">{t('sort_by_context')}</Select.Option>
              </Select>
              {hotSortField !== 'default' && (
                <CaretUpOutlined
                  style={{ color: hotSortOrder === 'asc' ? '#722ed1' : '#ccc', cursor: 'pointer', fontSize: 12 }}
                  onClick={() => setHotSortOrder('asc')}
                  title={t('ascending')}
                />
              )}
              {hotSortField !== 'default' && (
                <CaretDownOutlined
                  style={{ color: hotSortOrder === 'desc' ? '#722ed1' : '#ccc', cursor: 'pointer', fontSize: 12 }}
                  onClick={() => setHotSortOrder('desc')}
                  title={t('descending')}
                />
              )}
            </div>
          </div>
          <Row gutter={[20, 20]}>
            {sortModels(hotModels, hotSortField, hotSortOrder).slice((hotPage - 1) * hotPageSize, hotPage * hotPageSize).map(model => (
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={6} key={model.id}>
                {renderModelCard(model)}
              </Col>
            ))}
          </Row>
          {hotModels.length > 8 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16, marginBottom: 24 }}>
              <Pagination
                current={hotPage}
                pageSize={hotPageSize}
                total={hotModels.length}
                onChange={setHotPage}
                onShowSizeChange={(current, size) => {
                  setHotPageSize(size);
                  setHotPage(1);
                }}
                showSizeChanger
                pageSizeOptions={[10, 20, 30]}
                locale={{
                  items_per_page: t('pagination_items_per_page'),
                  jump_to: t('pagination_jump_to'),
                  page: t('pagination_page'),
                }}
              />
            </div>
          )}
        </div>
      )}

      {/* 模型列表标题 */}
      <div style={{ marginBottom: 16, padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h3 style={{ marginBottom: 0 }}>
            {searchText || selectedTypes.length > 0 || selectedUseCases.length > 0 ? t('search_results') : t('all_models')}
            <span style={{ color: '#999', fontSize: 14, marginLeft: 8 }}>({models.length} {t('models_count')})</span>
          </h3>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Select
            value={allSortField}
            onChange={handleAllSortChange}
            style={{ width: 120 }}
            size="small"
          >
            <Select.Option value="default">{t('default_sort')}</Select.Option>
            <Select.Option value="model_size">{t('sort_by_size')}</Select.Option>
            <Select.Option value="price">{t('sort_by_price')}</Select.Option>
            <Select.Option value="context_length">{t('sort_by_context')}</Select.Option>
          </Select>
          {allSortField !== 'default' && (
            <CaretUpOutlined
              style={{ color: allSortOrder === 'asc' ? '#722ed1' : '#ccc', cursor: 'pointer', fontSize: 12 }}
              onClick={() => setAllSortOrder('asc')}
              title={t('ascending')}
            />
          )}
          {allSortField !== 'default' && (
            <CaretDownOutlined
              style={{ color: allSortOrder === 'desc' ? '#722ed1' : '#ccc', cursor: 'pointer', fontSize: 12 }}
              onClick={() => setAllSortOrder('desc')}
              title={t('descending')}
            />
          )}
        </div>
      </div>

      {/* 模型列表 */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>
      ) : models.length === 0 ? (
        <Empty description={t('no_models_found')} />
      ) : (
        <>
          <div style={{ padding: '0 40px' }}>
            <Row gutter={[20, 20]}>
              {sortModels(models, allSortField, allSortOrder).slice((allPage - 1) * allPageSize, allPage * allPageSize).map(model => (
                <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={6} key={model.id}>
                  {renderModelCard(model)}
                </Col>
              ))}
            </Row>
          </div>
          {models.length > 8 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24, marginBottom: 40, padding: '0 40px' }}>
              <Pagination
                current={allPage}
                pageSize={allPageSize}
                total={models.length}
                onChange={setAllPage}
                onShowSizeChange={(current, size) => {
                  setAllPageSize(size);
                  setAllPage(1);
                }}
                showSizeChanger
                pageSizeOptions={[10, 20, 30]}
                locale={{
                  items_per_page: t('pagination_items_per_page'),
                  jump_to: t('pagination_jump_to'),
                  page: t('pagination_page'),
                }}
              />
            </div>
          )}
          {models.length > 0 && models.length <= 8 && (
            <div style={{ textAlign: 'center', padding: '30px 0 20px', color: '#999', fontSize: 13 }}>
              {t('no_more_results')}
            </div>
          )}
        </>
      )}

      {/* 右侧悬浮按钮 */}
      <div style={{
        position: 'fixed',
        right: 24,
        bottom: 100,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        zIndex: 100,
      }}>
        <Tooltip title={t('all_models', '全部模型')} placement="left">
          <Button
            type={activeTab === 'all' ? 'primary' : 'default'}
            shape="circle"
            size="large"
            icon={<AppstoreOutlined />}
            onClick={() => setActiveTab('all')}
            style={{
              width: 48,
              height: 48,
              boxShadow: '0 4px 12px rgba(114, 46, 209, 0.3)',
            }}
          />
        </Tooltip>
        <Tooltip title={t('my_training', '我的训练')} placement="left">
          <Button
            type={activeTab === 'my-training' ? 'primary' : 'default'}
            shape="circle"
            size="large"
            icon={<ExperimentOutlined />}
            onClick={() => setActiveTab('my-training')}
            style={{
              width: 48,
              height: 48,
              boxShadow: '0 4px 12px rgba(114, 46, 209, 0.3)',
            }}
          />
        </Tooltip>
        <Tooltip title={t('price_compare', '价格对比')} placement="left">
          <Button
            shape="circle"
            size="large"
            icon={<BarChartOutlined />}
            onClick={() => window.location.href = '/compare'}
            style={{
              width: 48,
              height: 48,
              boxShadow: '0 4px 12px rgba(114, 46, 209, 0.3)',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              border: 'none',
            }}
          />
        </Tooltip>
      </div>

      {/* 样式 */}
      <style>{`
        .model-square-container {
          position: relative;
          margin-left: -12px;
          margin-right: -12px;
        }
        
        .bg-wrapper {
          position: relative;
          width: 100%;
          ${bgImage ? `background-image: url(${bgImage});` : ''}
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          min-height: 480px;
        }
        
        .bg-wrapper::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 80px;
          background: linear-gradient(to bottom, transparent, #f5f7fa);
          pointer-events: none;
        }
        
        .keyword-tag {
          cursor: pointer;
          padding: 4px 12px;
          border-radius: 16;
          margin: 0;
          transition: all 0.2s;
        }
        .keyword-tag:hover {
          background: #e6f7ff !important;
          border-color: #1890ff !important;
        }
        
        /* 背景图上的热门搜索标签 */
        .keyword-tag-bg {
          cursor: pointer;
          padding: 4px 12px;
          border-radius: 7px;
          margin: 0;
          transition: all 0.2s;
          background: rgba(255,255,255,0.9) !important;
          border-color: rgba(255,255,255,0.6) !important;
          color: #333 !important;
        }
        .keyword-tag-bg:hover {
          background: #fff !important;
          border-color: #722ed1 !important;
          color: #722ed1 !important;
        }
        
        /* 类型/场景标签 */
        .type-tag-bg {
          cursor: pointer;
          padding: 3px 15px;
          border-radius: 4px;
          margin: 0;
          transition: all 0.2s;
          background: #fff !important;
          border: 1px solid #d9d9d9 !important;
          color: #333 !important;
          font-size: 13px;
        }
        .type-tag-bg:hover {
          background: #f0f0f0 !important;
          border-color: #722ed1 !important;
          color: #722ed1 !important;
        }
        
        /* 选中状态 */
        .type-tag-active {
          cursor: pointer;
          padding: 3px 15px;
          border-radius: 4px;
          margin: 0;
          transition: all 0.2s;
          background: #f9f0ff !important;
          border: 1px solid #d3adf7 !important;
          color: #722ed1 !important;
          font-size: 13px;
        }
        .type-tag-active:hover {
          background: #f0e6ff !important;
        }
        
        .model-card-wrapper {
          background: #fff;
          border-radius: 12px;
          border: 1px solid #f0f0f0;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          height: 185px;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        
        .model-card-wrapper:hover {
          border-color: #722ed1;
          box-shadow: 0 8px 24px rgba(114, 46, 209, 0.15);
          transform: translateY(-2px);
        }
        
        .model-card-inner {
          height: 100%;
          position: relative;
        }
        
        .model-front, .model-back {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 12px;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        
        .model-back {
          opacity: 0;
          pointer-events: none;
          background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
          color: #1a1a2e;
        }
        
        .model-card-wrapper:hover .model-front {
          opacity: 0;
        }
        
        .model-card-wrapper:hover .model-back {
          opacity: 1;
        }
        
        /* 正面样式 */
        .model-header {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
        }
        
        .model-logo {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          background: #f5f7fa;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        
        .model-logo svg {
          width: 22px !important;
          height: 22px !important;
        }
        
        .model-brand {
          flex: 1;
        }
        
        .brand-label {
          font-size: 13px;
          color: #595959;
          font-weight: 500;
        }
        
        .model-type-right {
          flex-shrink: 0;
        }
        
        .type-tag {
          font-size: 11px !important;
          padding: 2px 10px !important;
          line-height: 20px !important;
          margin: 0 !important;
          color: #0958d9 !important;
          background: #e6f4ff !important;
          border-color: #91caff !important;
          border-radius: 4px !important;
        }
        
        .model-version {
          margin: 8px 0;
        }
        
        .version-name {
          font-size: 13px;
          font-weight: 600;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          color: #262626;
        }
        
        .model-release {
          margin-bottom: 4px;
        }
        
        .release-date {
          font-size: 11px;
          color: #8c8c8c;
        }
        
        .model-tags {
          display: flex;
          flex-wrap: nowrap;
          gap: 5px;
          margin-bottom: auto;
          margin-top: 8px;
          max-height: 24px;
          overflow: hidden;
        }
        
        .feature-tag {
          font-size: 11px !important;
          padding: 2px 10px !important;
          line-height: 18px !important;
          margin: 0 !important;
          background: #f9f0ff !important;
          border-color: #d3adf7 !important;
          color: #722ed1 !important;
          border-radius: 4px !important;
        }
        
        .model-divider {
          height: 1px;
          background: #f0f0f0;
          margin: 6px 0;
        }
        
        .model-prices {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 6px 0 0;
          border-top: 1px solid #f0f0f0;
          flex-shrink: 0;
          margin-top: auto;
        }
        
        .price-item {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: center;
          gap: 4px;
        }
        
        .price-label {
          font-size: 10px;
          color: #8c8c8c;
        }
        
        .price-value {
          font-size: 11px;
          font-weight: 600;
          color: #722ed1;
        }
        
        .price-divider-line {
          width: 1px;
          height: 16px;
          background: #e8e8e8;
        }
        
        .price-single {
          flex: 1;
          justify-content: flex-start !important;
          padding-left: 8px;
        }
        
        .price-free {
          justify-content: flex-start !important;
          padding-left: 8px;
        }
        
        .price-free .price-value {
          color: #52c41a;
          font-size: 14px;
        }
        
        /* 背面样式 */
        .back-header {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
          margin-bottom: 0;
        }
        
        .type-tag-back {
          font-size: 11px !important;
          padding: 2px 10px !important;
          line-height: 20px !important;
          margin: 0 !important;
          background: #722ed1 !important;
          border-color: #722ed1 !important;
          color: #fff !important;
          border-radius: 10px !important;
        }
        
        .back-section {
          margin-bottom: 6px;
        }
        
        .back-middle {
          flex: 1;
          overflow: hidden;
          margin-top: 10px;
        }
        
        .section-label {
          font-size: 11px;
          font-weight: 600;
          color: #444;
          margin-bottom: 2px;
        }
        
        .back-desc {
          font-size: 12px;
          color: #333;
          margin: 0 0 4px 0;
          line-height: 1.4;
          height: 33.6px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        .back-caps {
          display: flex;
          flex-wrap: nowrap;
          gap: 3px;
          max-height: 24px;
          overflow: hidden;
        }
        
        .cap-tag {
          font-size: 11px !important;
          padding: 2px 8px !important;
          line-height: 18px !important;
          margin: 0 !important;
          background: #f9f0ff !important;
          border-color: #d3adf7 !important;
          color: #722ed1 !important;
          border-radius: 4px !important;
        }
        
        .back-specs {
          display: flex;
          justify-content: space-between;
          padding: 6px 0 0;
          border-top: 1px solid rgba(114, 46, 209, 0.2);
          flex-shrink: 0;
          align-items: center;
        }
        
        .spec-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 4px;
        }
        
        .spec-item-left {
          flex: 1;
        }
        
        .spec-item-right {
          flex-shrink: 0;
        }
        
        .spec-label {
          font-size: 10px;
          color: #666;
          white-space: nowrap;
        }
        
        .spec-value {
          font-size: 12px;
          font-weight: 600;
          color: #722ed1;
          white-space: nowrap;
        }

        /* 训练模型卡片 hover 效果 */
        .model-card:hover .card-action-overlay {
          opacity: 1 !important;
        }

        .card-action-overlay button {
          min-width: 120px;
        }
        
      `}</style>
    </div>
  );
};

export default ModelSquare;
